{
  "a11y": {
    "home": "Dubai To-Do — главная",
    "menu": "Меню",
    "closeMenu": "Закрыть меню",
    "search": "Поиск",
    "language": "Язык: {{name}}",
    "mainNav": "Основное меню",
    "categories": "Категории",
    "open": "Открыть: {{title}}",
    "breadcrumb": "Навигационная цепочка",
    "saved": "Избранное",
    "account": "Аккаунт",
    "save": "Сохранить: {{title}}"
  },
  "nav": {
    "tours": "Экскурсии",
    "boats": "Яхты и лодки",
    "desert": "Пустыня",
    "attractions": "Что посмотреть",
    "dayTrips": "Поездки на день",
    "home": "Главная",
    "events": "События",
    "guides": "Путеводитель",
    "hotels": "Где остановиться"
  },
  "home": {
    "metaTitle": "Чем заняться в Дубае — сафари, экскурсии и круизы на доу",
    "metaDescription": "Экскурсии в Дубае по реальным отзывам: сафари в пустыне, обзорные экскурсии, круизы на доу, билеты на Бурдж-Халифу, воздушный шар и поездки в Абу-Даби.",
    "heroTitle": "Экскурсии и туры в Дубае",
    "heroLead": "Сафари, круизы на доу и полёты на шаре — с рейтингом по отзывам.",
    "featuredTitle": "Выбор недели",
    "featuredEyebrow": "Впечатления, которые стоят вашего времени",
    "viewAllExperiences": "Все впечатления",
    "moodTitle": "Под настроение",
    "moodEyebrow": "Подборки идей на любой случай",
    "heroAlt": "Небоскрёбы Дубая на закате, вид с террасы у воды",
    "guideTitle": "Чем заняться в Дубае: по категориям",
    "guidesTitle": "Путеводитель по Дубаю",
    "guidesEyebrow": "Свежие статьи: маршруты, сезоны и советы для поездки",
    "guideCount_one": "{{count}} вариант",
    "guideCount_few": "{{count}} варианта",
    "guideCount_many": "{{count}} вариантов",
    "guideCount_other": "{{count}} варианта",
    "guide": {
      "desert-safari": {
        "text": "Главное приключение Дубая: джип-сафари по дюнам, квадроциклы и сэндбординг, катание на верблюдах и ужин-барбекю в лагере в пустыне. Вечернее сафари — это закат и шоу, утреннее — прохладные и тихие дюны, а с ночёвкой — ночь под звёздами.",
        "link": "Все сафари в пустыне"
      },
      "city-tours": {
        "text": "Обзорная экскурсия по Дубаю за полдня или день: квартал Аль-Фахиди, золотой рынок и рынок специй, переправа на абре через Дубай-Крик, мечеть Джумейра и фотостопы у Бурдж-эль-Араб, Пальмы Джумейра и Дубай Фрейм.",
        "link": "Все обзорные экскурсии"
      },
      "attractions": {
        "text": "Билеты на смотровые площадки Бурдж-Халифы, в Дубай Фрейм, Музей будущего, Дубайский аквариум и тематические парки — с фиксированным временем входа и без длинных очередей.",
        "link": "Все билеты"
      },
      "water-sports": {
        "text": "Гидроцикл мимо Бурдж-эль-Араб и Атлантиса, парасейлинг над Дубай Мариной, флайборд, снорклинг и дайвинг: в тёплом Персидском заливе водные развлечения доступны почти круглый год.",
        "link": "Все прогулки на гидроцикле и водные развлечения"
      },
      "dhow-cruise": {
        "text": "Ужин на доу — один из самых простых и приятных вечеров в Дубае: традиционное деревянное судно, шведский стол и шоу. Круиз по Дубай-Крик проходит мимо старых рынков, по Дубай Марине — среди небоскрёбов.",
        "link": "Все круизы на доу"
      },
      "family": {
        "text": "Дубай с детьми: аквапарки и парки развлечений, океанариумы, настоящий снег и сады цветов — и ограничения по возрасту и росту, которые стоит проверить перед бронированием.",
        "link": "Всё для отдыха с детьми"
      },
      "day-trips": {
        "text": "До Абу-Даби около полутора часов: Большая мечеть шейха Зайда, Лувр Абу-Даби и остров Яс. Или горы Хатты, или фьорды Мусандама в Омане (нужен паспорт).",
        "link": "Все экскурсии в Абу-Даби и поездки на день"
      },
      "scenic-flights": {
        "text": "Дубай с высоты: полёт на воздушном шаре над пустыней на рассвете, часто с завтраком и шоу соколов, или вертолётная экскурсия над Бурдж-Халифой, Пальмой Джумейра и Дубай Мариной.",
        "link": "Все полёты"
      }
    },
    "tipsTitle": "Полезно знать перед поездкой",
    "tipsEyebrow": "Как спланировать дни в Дубае",
    "tips": {
      "season": {
        "title": "Когда ехать",
        "text": "С ноября по март в Дубае тепло и солнечно, вечера комфортные — высокий сезон для сафари, морских прогулок и пляжа. С июня по сентябрь жара часто выше 40 °C: сафари лучше планировать на раннее утро или вечер, а днём выбирать развлечения в помещении."
      },
      "customs": {
        "title": "Местные правила",
        "text": "В мечетях, на рынках и в старом городе плечи и колени должны быть закрыты, а женщинам в Большой мечети шейха Зайда нужен платок. В Рамадан большинство экскурсий проводится, иногда по другому расписанию, а вечерами после ифтара город оживает."
      },
      "booking": {
        "title": "Бронирование и трансфер",
        "text": "Популярные сафари, круизы на закате и слоты на Бурдж-Халифу в сезон раскупают заранее — бронируйте вперёд. Во многих экскурсиях есть трансфер из отеля и бесплатная отмена за 24 часа; точные условия указаны у каждого предложения."
      },
      "ranking": {
        "title": "Как мы составляем рейтинг",
        "text": "Не только по звёздам: 5,0 при трёх отзывах мало что значит, поэтому мы учитываем и оценку, и число отзывов. Экскурсии — от Viator, прогулки на яхтах и лодках — от Click&Boat; бронирование проходит на сайте партнёра, и мы можем получить комиссию — для вас цена не меняется."
      }
    },
    "faqTitle": "Частые вопросы",
    "faqEyebrow": "Чем заняться в Дубае — коротко",
    "faq": {
      "mustDo": {
        "q": "Что обязательно посмотреть в Дубае в первый раз?",
        "a": "Вечернее сафари в пустыне, смотровую площадку Бурдж-Халифы, круиз на доу по Дубай-Крик или в Дубай Марине, прогулку по старым рынкам с переправой на абре и день на пляже или на воде у Пальмы Джумейра. Если есть лишний день — съездите в Абу-Даби."
      },
      "safari": {
        "q": "Какое сафари в пустыне выбрать?",
        "a": "Самое популярное — вечернее: джип-сафари по дюнам, катание на верблюдах, сэндбординг и ужин-барбекю с шоу в лагере. Утреннее сафари короче и прохладнее, с ночёвкой — это ночь под звёздами, а на квадроциклах и багги можно рулить самому. С маленькими детьми или при проблемах со спиной лучше выбрать сафари без езды по дюнам."
      },
      "flights": {
        "q": "Стоит ли лететь на воздушном шаре или вертолёте в Дубае?",
        "a": "Для многих это главное впечатление поездки. Воздушные шары взлетают над пустыней на рассвете, поэтому трансфер забирает очень рано, ещё затемно; обычно в программу входит завтрак в лагере. Вертолётные экскурсии длятся примерно от 12 минут и пролетают над Бурдж-Халифой, Бурдж-эль-Араб, Пальмой Джумейра и Дубай Мариной."
      },
      "advance": {
        "q": "Нужно ли бронировать экскурсии в Дубае заранее?",
        "a": "Да, особенно с ноября по март и в праздники, когда популярные сафари, круизы на закате и слоты на Бурдж-Халифу раскупают. Ранняя бронь фиксирует цену, а многие экскурсии всё равно можно отменить бесплатно."
      },
      "cancel": {
        "q": "Можно ли отменить бронирование?",
        "a": "Многие экскурсии можно бесплатно отменить за 24 часа до начала. Точные условия зависят от экскурсии и указаны на странице партнёра до оплаты."
      },
      "wear": {
        "q": "Как одеваться на экскурсии в Дубае?",
        "a": "Лёгкая дышащая одежда, головной убор и солнцезащитный крем. В мечетях, на рынках и в старом городе закрывайте плечи и колени; женщинам в Большой мечети шейха Зайда нужен ещё и платок. В пустыне удобнее закрытая обувь, а зимними вечерами пригодится лёгкая куртка."
      },
      "kids": {
        "q": "Подходит ли Дубай для отдыха с детьми?",
        "a": "Очень. Аквапарки, тематические парки, аквариумы, спокойные морские прогулки и семейные сафари позволяют спланировать отдых для любого возраста. У многих экскурсий есть детские цены; проверяйте минимальный возраст, особенно для езды по дюнам и водных развлечений."
      },
      "abuDhabi": {
        "q": "Можно ли съездить из Дубая в Абу-Даби на один день?",
        "a": "Да. До Абу-Даби около полутора часов на машине. Экскурсия в Абу-Даби из Дубая обычно включает Большую мечеть шейха Зайда, а также Лувр Абу-Даби, дворец Каср-аль-Ватан или парки острова Яс, с трансфером из отеля в Дубае."
      },
      "newYear": {
        "q": "Чем заняться в Дубае в новогоднюю ночь?",
        "a": "Посмотреть салют у Бурдж-Халифы, на Пальме или в Марине, пойти на гала-ужин или вечеринку в бич-клубе, встретить полночь на доу или яхте. На нашей новогодней странице — вечеринки и круизы сезона и советы о перекрытиях дорог и метро."
      },
      "booking": {
        "q": "Бронирование проходит на Dubai To-Do?",
        "a": "Мы помогаем сравнить варианты, а бронирование и оплата проходят на сайте партнёра — Viator для экскурсий, Click&Boat для прогулок на яхтах и лодках — по его условиям и с его службой поддержки. Если вы бронируете по нашим ссылкам, мы можем получить комиссию; для вас цена не меняется."
      }
    },
    "eventsTitle": "События на этой неделе",
    "eventsEyebrow": "Бранчи, стендап, концерты и не только — в ближайшие 7 дней",
    "viewAllEvents": "Все события",
    "nyeTitle": "Новый год в Дубае",
    "nyeEyebrow": "Вечеринки, гала-ужины и круизы 31 декабря",
    "nyeMore": "Всё о Новом годе"
  },
  "search": {
    "label": "Что вы ищете?",
    "placeholder": "Что вы ищете?",
    "submit": "Найти",
    "landmark": "Поиск по Dubai To-Do",
    "searchFor": "Искать «{{query}}»",
    "categories": "Категории",
    "popularTitle": "Часто ищут",
    "suggestions": "Подсказки",
    "popular": [
      {
        "label": "Бурдж-Халифа",
        "q": "бурдж халифа"
      },
      {
        "label": "Абу-Даби",
        "q": "абу даби"
      },
      {
        "label": "Воздушный шар",
        "q": "шар"
      },
      {
        "label": "Вертолёт",
        "q": "вертолет"
      },
      {
        "label": "Гидроцикл",
        "q": "гидроцикл"
      },
      {
        "label": "Квадроцикл",
        "q": "квадроцикл"
      },
      {
        "label": "Дубай Марина",
        "q": "марина"
      },
      {
        "label": "Круиз с ужином",
        "q": "ужин"
      },
      {
        "label": "Индивидуальный тур",
        "q": "индивидуальн"
      },
      {
        "label": "Круиз на доу",
        "q": "доу"
      }
    ]
  },
  "strip": {
    "boats": "Яхты\nи круизы"
  },
  "collections": {
    "desert-safari": {
      "title": "Сафари в пустыне",
      "short": "Сафари\nв пустыне",
      "intro": "Катание по дюнам на внедорожнике, верблюды, сэндбординг и ужин в пустынном лагере под звёздами — классический способ увидеть дюны за городом.",
      "meta": "Сафари в пустыне Дубая: вечернее сафари с ужином-барбекю и шоу, утренний дюн-башинг, квадроциклы, катание на верблюдах и ночёвка в лагере.",
      "metaFrom": "Сафари в пустыне Дубая от {{price}}: вечернее сафари с ужином-барбекю и шоу, утренний джиппинг, индивидуальные и VIP-туры, квадроциклы и ночёвка в лагере.",
      "seoTitle": "Сафари в пустыне Дубай: вечернее, утреннее, с ночёвкой",
      "heading": "Сафари в пустыне в Дубае",
      "guideTitle": "Как выбрать сафари в пустыне",
      "guide": [
        {
          "h": "Вечернее, утреннее или с ночёвкой?",
          "p": [
            "Вечернее сафари — классика: трансфер из отеля после обеда, дюн-башинг на внедорожнике, остановка на закат, а затем лагерь в пустыне с катанием на верблюде, сэндбордингом, хной, ужином-барбекю и шоу — танцем танура и огненным шоу. В город обычно возвращаются около 21:00.",
            "Утреннее сафари короче, прохладнее и спокойнее — подходит, если вечера уже заняты. Сафари с ночёвкой добавляет ночь в лагере под звёздами и завтрак в пустыне."
          ]
        },
        {
          "h": "Дюн-башинг, квадроциклы и багги",
          "p": [
            "Дюн-башинг — это когда опытный водитель на скорости ведёт внедорожник по барханам: захватывает дух, но трясёт. Если хотите за руль сами, добавьте квадроцикл или багги в красных дюнах Лахбаба или закажите индивидуальное сафари с машиной только для вашей компании.",
            "Спокойнее — сафари в заповеднике Аль-Мармум: там главное не адреналин, а дикая природа, ретро-лендроверы и соколиная охота.",
            "В групповом сафари вы едете во внедорожнике с другими туристами — обычно по шесть человек в машине — и делите лагерь с другими группами. В индивидуальном машина и водитель только ваши, со своим временем выезда и темпом; VIP- и люкс-пакеты добавляют небольшой лагерь, обслуживание за столом вместо очереди к шведскому столу или поездку на винтажном Land Rover."
          ]
        },
        {
          "h": "Что взять с собой и как бронировать",
          "p": [
            "Наденьте лёгкую закрытую одежду и обувь, которую не жалко набить песком, возьмите очки, солнцезащитный крем и кофту на вечер — зимой ночью в пустыне прохладно.",
            "Сравнивайте, что входит в тур: трансфер, тип лагеря, ужин (барбекю, вегетарианские блюда), напитки и доплаты вроде квадроциклов. Большинство сафари можно бесплатно отменить за 24 часа, а список отсортирован по отзывам — сверху туры с самыми стабильными оценками."
          ]
        }
      ],
      "faq": [
        {
          "q": "Какое сафари лучше — утреннее или вечернее?",
          "a": "Вечернее — полная программа: джиппинг, закат и лагерь с ужином-барбекю и шоу. Утреннее короче и прохладнее: дюны и развлечения есть, лагеря нет. Хотите лагерь — выбирайте вечер, вечера заняты — утро."
        },
        {
          "q": "Сколько длится вечернее сафари в Дубае?",
          "a": "Около шести-семи часов вместе с трансфером: выезд после обеда, примерно 30–45 минут дюн-башинга, закат и вечер в лагере с ужином и шоу."
        },
        {
          "q": "Можно ли на дюн-башинг детям и беременным?",
          "a": "Дюн-башинг не рекомендуют при беременности, проблемах со спиной или сердцем и совсем маленьким детям. Многие операторы предлагают лагерь и верблюдов без езды по дюнам — выбирайте сафари без дюн-башинга или эко-сафари."
        },
        {
          "q": "Когда лучше ехать на сафари в пустыню?",
          "a": "С октября по апрель, когда днём тепло, а вечером в пустыне комфортно. Сафари проводят круглый год, но с июня по сентябрь комфортны только утренние и вечерние поездки."
        },
        {
          "q": "Входит ли ужин в сафари?",
          "a": "На вечернем сафари и сафари с ночёвкой — как правило, да: шведский стол или барбекю в лагере, безалкогольные напитки, чай и кофе. Проверьте в описании тура, есть ли вегетарианские блюда и алкоголь."
        },
        {
          "q": "Что надеть на сафари в пустыне?",
          "a": "Лёгкую свободную одежду, закрывающую плечи и колени, закрытую обувь или сандалии, в которые не жалко набрать песка, очки и платок от пыли. С ноября по март возьмите куртку или свитер: после заката в пустыне быстро холодает. Покрывать голову женщинам не нужно."
        },
        {
          "q": "Групповое, индивидуальное или VIP-сафари?",
          "a": "Групповое — классика: в машине и в лагере с другими туристами. Индивидуальное — своя машина, водитель и время. VIP и люкс добавляют более тихий лагерь, обслуживание за столом и, например, соколиную охоту — что входит, указано в описании тура."
        },
        {
          "q": "Сколько стоит сафари в пустыне в Дубае?",
          "a": "Зависит от формата: групповое вечернее сафари — самое недорогое, индивидуальное, VIP и с ночёвкой стоят в разы больше, а квадроцикл или багги часто оплачиваются отдельно. На каждой карточке — актуальная цена, так что сравнивать удобно."
        },
        {
          "q": "Где проходит сафари в пустыне?",
          "a": "В красных дюнах к юго-востоку от города, в основном у Лахбаба и Аль-Бадайера — 45 минут – час на машине от Даунтауна или Дубай Марины; экологические сафари едут в заповедник Аль-Мармум. Почти все туры забирают из отеля, адрес знать не нужно."
        }
      ]
    },
    "city-tours": {
      "title": "Обзорные экскурсии",
      "short": "Обзорные\nэкскурсии",
      "intro": "Дубай с гидом — от базаров и ветряных башен старого города до небоскрёбов Даунтауна и Пальмы.",
      "meta": "Обзорные экскурсии по Дубаю с гидом: Бурдж-Халифа и Даунтаун, мечеть Джумейра, Бурдж-эль-Араб, Пальма Джумейра, Дубай Марина и Dubai Frame — на полдня, на день или индивидуально.",
      "seoTitle": "Обзорная экскурсия по Дубаю: Даунтаун, Пальма и Марина",
      "heading": "Обзорные экскурсии по Дубаю",
      "guideTitle": "Дубай на обзорной экскурсии",
      "guide": [
        {
          "h": "Старый Дубай и залив Дубай-Крик",
          "p": [
            "Большинство экскурсий на целый день заезжают и туда, где начинался Дубай: к ветряным башням Аль-Фахиди, на абре через Дубай-Крик, на золотой рынок и рынок специй в Дейре. Экскурсии только по старому городу — пешком и подробнее — в разделе «Старый Дубай и Крик»."
          ]
        },
        {
          "h": "Современный Дубай: Даунтаун, Джумейра и Пальма",
          "p": [
            "Современная часть типичной экскурсии — фотостопы у мечети Джумейра, Бурдж-эль-Араба, на Пальме Джумейра у Атлантиса, в Дубай Марине, у Dubai Frame и в Даунтауне с Бурдж-Халифой и Dubai Mall. В некоторые туры входят смотровая площадка Бурдж-Халифы или поездка на монорельсе Пальмы.",
            "Экскурсия на полдня охватывает либо старый, либо новый город, на целый день — оба, обычно с обедом."
          ]
        },
        {
          "h": "Группа, индивидуально или на автобусе?",
          "p": [
            "Экскурсия в мини-группе — самый простой способ увидеть главное с гидом. Индивидуальный тур позволяет самим выбрать темп и остановки — удобно с детьми или для фотосъёмки. Автобусы hop-on hop-off, гастрономические и вечерние туры — хорошая альтернатива для тех, кто хочет гулять в своём ритме.",
            "В большинство экскурсий с гидом входит трансфер из отеля. Список отсортирован по отзывам, большинство туров можно бесплатно отменить за 24 часа."
          ]
        }
      ],
      "faq": [
        {
          "q": "Сколько длится обзорная экскурсия по Дубаю?",
          "a": "Экскурсия на полдня занимает четыре-пять часов и охватывает либо старый Дубай, либо современный город. Экскурсия на целый день длится семь-восемь часов и объединяет оба, часто с обедом."
        },
        {
          "q": "Есть ли дресс-код для посещения мечетей?",
          "a": "Да: плечи и колени закрыты у всех, женщины в мечети Джумейра или Большой мечети Абу-Даби покрывают волосы. Туры с посещением мечети предупреждают об этом заранее, в некоторых мечетях абаю выдают на входе."
        },
        {
          "q": "Можно ли совместить экскурсию с Бурдж-Халифой?",
          "a": "Да. В некоторые экскурсии входит билет At the Top; иначе забронируйте билет на Бурдж-Халифу на конец экскурсии — слоты на закат самые популярные и раскупаются первыми."
        },
        {
          "q": "Стоит ли ехать на экскурсию по городу летом?",
          "a": "Да, если выбрать тур на машине с кондиционером и короткими прогулками. С июня по сентябрь утренние и вечерние экскурсии намного комфортнее дневных."
        }
      ]
    },
    "attractions": {
      "title": "Достопримечательности и билеты",
      "short": "Аттракционы\nи билеты",
      "intro": "Смотровые площадки, тематические парки, аквариумы и музеи — билеты на самые известные места Дубая в одном списке.",
      "meta": "Билеты на главные достопримечательности Дубая: Бурдж-Халифа At the Top, Dubai Frame, Музей будущего, Dubai Aquarium, аквапарки и парки развлечений.",
      "seoTitle": "Билеты на достопримечательности Дубая: Бурдж-Халифа",
      "heading": "Достопримечательности Дубая и билеты",
      "guideTitle": "Как покупать билеты на достопримечательности Дубая",
      "guide": [
        {
          "h": "Смотровые площадки и символы города",
          "p": [
            "Смотровые площадки At the Top на 124-м и 125-м этажах Бурдж-Халифы — самый известный вид на город; площадка SKY на 148-м этаже выше, с лаунжем и без толпы. Dubai Frame показывает старый и новый Дубай со стеклянного моста, а Музей будущего сочетает эффектную архитектуру с иммерсивными выставками.",
            "Билеты продаются на конкретное время, и слоты на закат в Бурдж-Халифе часто раскупают за несколько дней — бронируйте заранее и приходите чуть раньше."
          ]
        },
        {
          "h": "Аквариумы, аквапарки и парки развлечений",
          "p": [
            "Dubai Aquarium & Underwater Zoo в Dubai Mall и The Lost Chambers в Атлантисе — лёгкие полдня с детьми. На целый день — аквапарк Aquaventure на Пальме и крытые парки развлечений, одни из самых популярных билетов в городе.",
            "В самые жаркие месяцы, с июня по сентябрь, лучший план — достопримечательности под крышей."
          ]
        },
        {
          "h": "Как сэкономить время и деньги",
          "p": [
            "Бронь заранее фиксирует цену и время и позволяет обойти очереди в кассы самых популярных мест. Комбо-билеты — например, Бурдж-Халифа плюс аквариум — обычно дешевле, чем по отдельности.",
            "Проверяйте, что входит в билет, возрастные категории и условия отмены. Список отсортирован по отзывам — сверху места с самыми стабильными оценками."
          ]
        }
      ],
      "faq": [
        {
          "q": "Нужно ли покупать билеты на Бурдж-Халифу заранее?",
          "a": "Да. Билеты продаются на конкретное время, а в кассе цена часто выше. Слоты на закат заканчиваются первыми, особенно с ноября по март и в выходные."
        },
        {
          "q": "Какой билет на Бурдж-Халифу выбрать?",
          "a": "Большинству хватает At the Top (124-й и 125-й этажи). At the Top SKY (148-й этаж) дороже, но там меньше людей и есть лаунж с напитками."
        },
        {
          "q": "Куда пойти в Дубае в сильную жару?",
          "a": "В крытые достопримечательности: Музей будущего, Dubai Aquarium & Underwater Zoo, The Lost Chambers, крытые парки развлечений и смотровые площадки — везде работают кондиционеры."
        },
        {
          "q": "Есть ли скидки для детей?",
          "a": "В большинстве мест есть детские билеты, маленькие дети часто проходят бесплатно. Возрастные границы везде разные — проверяйте условия перед покупкой."
        }
      ]
    },
    "water-sports": {
      "title": "Гидроциклы и водные развлечения",
      "short": "Водные\nразвлечения",
      "intro": "Прогулки на гидроцикле мимо Бурдж-эль-Араба, Атлантиса и небоскрёбов Марины — а ещё парасейлинг, флайборд и дайвинг в тёплых водах залива.",
      "meta": "Гидроцикл в Дубае: прогулки с инструктором мимо Бурдж-эль-Араба, Атлантиса и Пальмы Джумейра, а также парасейлинг, флайборд, снорклинг и дайвинг.",
      "metaFrom": "Гидроцикл в Дубае от {{price}}: прогулки с инструктором мимо Бурдж-эль-Араба, Атлантиса и Пальмы Джумейра, а также парасейлинг, флайборд, снорклинг и дайвинг.",
      "seoTitle": "Гидроцикл в Дубае: прогулки и водные развлечения",
      "heading": "Гидроциклы и водные развлечения в Дубае",
      "guideTitle": "Водные развлечения в Дубае: чего ждать",
      "guide": [
        {
          "h": "Прогулки на гидроцикле: маршруты и длительность",
          "p": [
            "Гидроцикл — самый популярный способ увидеть Дубай с воды. Маршрут зависит от длительности: за 30 минут обычно доезжают до Бурдж-эль-Араба и фотографируются; за час добавляются Атлантис и внешний полумесяц Пальмы Джумейра; прогулки от полутора до двух часов идут дальше, к Дубай Марина, JBR и колесу обозрения Ain Dubai.",
            "Стартуют из Dubai Harbour и Марины, из Джумейры рядом с Бурдж-эль-Арабом и с Пальмы. На многих маршрутах есть остановки для фото на фоне небоскрёбов — снимает обычно гид."
          ]
        },
        {
          "h": "С гидом или аренда, одному или вдвоём",
          "p": [
            "В Дубае на гидроцикле выходят с гидом: группа едет вдоль берега за инструктором — за пределами отмеченных зон проката иначе нельзя. Прав не нужно; перед стартом инструктаж и спасательный жилет.",
            "Большинство гидроциклов двухместные, поэтому пары и родители с ребёнком часто едут на одном — пассажир сидит за водителем. Водителю обычно должно быть не меньше 16 лет; возрастные ограничения организатора указаны в описании."
          ]
        },
        {
          "h": "Парасейлинг, флайборд и не только",
          "p": [
            "Парасейлинг поднимает высоко над пляжем и Дубай Марина — в одиночку или вдвоём. Флайборд и ховерборд поднимают над водой струёй воды — инструктор рядом всё время. Банан, вейкборд и сап — простые варианты для компаний и семей."
          ]
        },
        {
          "h": "Снорклинг и дайвинг",
          "p": [
            "Залив спокойный и тёплый, у побережья есть рифы и затонувшие суда, а вода прозрачнее — на восточном побережье у Фуджейры и в Мусандаме. Пробные погружения подходят новичкам без сертификата, сертифицированные дайверы бронируют погружения с гидом.",
            "Вода даже зимой теплее 20 °C, а летом прогревается до 30 °C и выше, так что водные развлечения доступны круглый год — летом лучше рано утром."
          ]
        }
      ],
      "faq": [
        {
          "q": "Сколько длится прогулка на гидроцикле в Дубае?",
          "a": "От 30 минут до двух часов. Получаса хватает до Бурдж-эль-Араба, за час добавляются Атлантис и Пальма, а длинные маршруты доходят до Дубай Марина и Ain Dubai."
        },
        {
          "q": "Сколько стоит прокат гидроцикла в Дубае?",
          "a": "Зависит от длительности и от того, указана цена за гидроцикл (на одного или двоих) или за человека: 30 минут до Бурдж-эль-Араба — самый недорогой вариант, часовые прогулки к Атлантису и Марине дороже. Актуальная цена — на каждой карточке."
        },
        {
          "q": "Откуда стартуют прогулки на гидроцикле к Бурдж-эль-Арабу?",
          "a": "Чаще всего из Dubai Harbour и Дубай Марины, некоторые — с пляжей Джумейры рядом с отелем. Получаса хватает, чтобы доехать, сфотографироваться на фоне Бурдж-эль-Араба и вернуться. Место встречи указано в описании."
        },
        {
          "q": "Можно ли прокатиться на гидроцикле вокруг Пальмы и Атлантиса?",
          "a": "Да, на прогулках от часа: маршрут идёт вдоль внешнего полумесяца Пальмы к Atlantis The Palm, обычно вместе с Бурдж-эль-Арабом. Быстрее всего туда из Dubai Harbour или с самой Пальмы."
        },
        {
          "q": "Можно ли кататься на одном гидроцикле вдвоём?",
          "a": "Да, большинство гидроциклов двухместные: один управляет, второй сидит сзади. Цена за гидроцикл или за человека — указано в описании."
        },
        {
          "q": "С какого возраста можно на гидроцикл в Дубае?",
          "a": "Управлять — с 16 лет. Дети могут ехать пассажиром за взрослым: на многих прогулках с 6 лет, на некоторых старше; ограничение оператора указано в описании."
        },
        {
          "q": "Нужны ли права, чтобы прокатиться на гидроцикле в Дубае?",
          "a": "Для прогулки с инструктором — нет: оператор проводит инструктаж, а маршрут ведёт гид. Самостоятельно управлять обычно можно с 16 лет; дети младше катаются пассажирами со взрослым."
        },
        {
          "q": "Можно ли, если не умею плавать?",
          "a": "На парасейлинге, гидроцикле и банане всегда надет спасательный жилет, так что уверенно плавать не обязательно. Для флайборда, снорклинга и дайвинга нужно спокойно чувствовать себя в воде."
        },
        {
          "q": "В какое время дня лучше заниматься водными видами спорта?",
          "a": "Утром, когда море спокойнее и не так жарко. Ближе к вечеру красивые фото на фоне небоскрёбов, но часто поднимается ветер."
        },
        {
          "q": "Откуда стартуют водные развлечения в Дубае?",
          "a": "Чаще всего из Дубай Марина, с пляжа JBR, из Джумейры и с Пальмы. Проверьте место встречи в описании тура — в одних есть трансфер из отеля, в других нет."
        }
      ]
    },
    "dhow-cruise": {
      "title": "Круизы на доу",
      "short": "Круизы\nна доу",
      "intro": "Традиционные деревянные доу по Дубай-Крику или вдоль Марины — чаще всего с ужином на борту, когда в городе зажигаются огни.",
      "meta": "Круизы на доу в Дубае: ужин на борту традиционной деревянной лодки на Дубай-Крик или в Дубай Марина — шведский стол, шоу и вид на ночной город.",
      "metaFrom": "Круиз на доу в Дубае от {{price}}: ужин на борту традиционной деревянной лодки на Дубай-Крик или в Дубай Марина — шведский стол, шоу и вид на ночной город.",
      "seoTitle": "Круиз на доу в Дубае: ужин на Крике и в Марине",
      "heading": "Круизы на доу в Дубае",
      "guideTitle": "Как выбрать круиз на доу",
      "guide": [
        {
          "h": "Дубай-Крик или Дубай Марина?",
          "p": [
            "Круиз по Дубай-Крику проходит мимо старого города: рынков Дейры, ветряных башен Аль-Фахиди и абр, снующих по заливу, — более традиционная, историческая атмосфера. Круиз по Дубай Марина скользит между подсвеченными небоскрёбами к Пальме Джумейра — современный ночной Дубай.",
            "Оба длятся около двух часов. Для первого вечера в Дубае эффектнее Марина; если небоскрёбы вы уже видели, атмосфернее Крик."
          ]
        },
        {
          "h": "Что входит в круиз с ужином",
          "p": [
            "В большинство круизов на доу входят шведский стол с международной и арабской кухней, безалкогольные напитки, вода, чай и кофе и шоу — например, танец танура. Места обычно на открытой верхней палубе и на нижней с кондиционером — зимой ради вида выбирайте верхнюю.",
            "В одних круизах есть трансфер из отеля, в других встреча на причале. Алкоголь подают только на лодках с лицензией — проверьте, если это важно."
          ]
        },
        {
          "h": "Не только классический ужин",
          "p": [
            "Есть круизы на закате, премиальные доу с меньшим числом гостей и сет-меню, а также частные доу для семей, дней рождения и компаний — самый уединённый вариант вечера на воде.",
            "Некоторые круизы по Крику заходят в Дубайский канал — через Бизнес-Бэй к небоскрёбам у Бурдж-Халифы; часть круизов из Марины выходит к Пальме и Ain Dubai. Маршрут указан в описании."
          ]
        }
      ],
      "faq": [
        {
          "q": "Что такое круиз на доу?",
          "a": "Доу — традиционная деревянная лодка Персидского залива, на которой когда-то торговали и добывали жемчуг. Сегодня в Дубае доу — плавучие рестораны: двухчасовой вечерний круиз с ужином, музыкой и огнями города с палубы."
        },
        {
          "q": "Сколько длится круиз на доу в Дубае?",
          "a": "Обычно около двух часов на воде, посадка за 30 минут до отправления. Большинство круизов с ужином начинаются между 19:30 и 20:30."
        },
        {
          "q": "Подходит ли круиз на доу для детей?",
          "a": "Да, это один из самых простых вечеров для семьи: лодки идут спокойно, есть шведский стол, а дети обычно платят меньше. На открытой палубе держите малышей рядом."
        },
        {
          "q": "Что надеть на круиз на доу?",
          "a": "Смарт-кэжуал. Зимой возьмите лёгкую куртку для верхней палубы; летом на нижней палубе работает кондиционер."
        },
        {
          "q": "Какой круиз на доу лучше?",
          "a": "Зависит от того, что хотите увидеть: Марину — ради небоскрёбов, Крик — ради старого Дубая. Список отсортирован по отзывам путешественников — сверху круизы с самыми стабильными оценками."
        },
        {
          "q": "Круиз по Марине и круиз на доу — одно и то же?",
          "a": "Часто да: круиз на доу по Марине — это и есть круиз на доу в Дубай Марине. Но некоторые ужины в Марине проходят на современном судне со стеклянной крышей или на яхте, а не на деревянной доу — тип судна указан в описании."
        },
        {
          "q": "Подают ли алкоголь на круизе?",
          "a": "Только на судах с лицензией, а их немного — в основном в Марине. Классические круизы с ужином подают безалкогольные напитки, воду, чай и кофе; если это важно, проверьте, что входит."
        },
        {
          "q": "Как забронировать круиз на доу?",
          "a": "Онлайн, на нужную дату: в выходные и в зимний сезон места на ужин заканчиваются. Выберите Крик или Марину, проверьте, входит ли трансфер из отеля, и сохраните подтверждение для посадки."
        }
      ]
    },
    "family": {
      "title": "С детьми",
      "short": "С детьми",
      "intro": "Развлечения, которые понравятся и детям, и взрослым: аквапарки, океанариумы, парки развлечений и настоящий снег — и ограничения по возрасту и росту, которые стоит проверить заранее.",
      "meta": "Дубай с детьми: аквапарки, парки развлечений, океанариумы, Ski Dubai и Miracle Garden — ограничения по возрасту и росту и что подойдёт малышам.",
      "seoTitle": "Дубай с детьми: развлечения для всей семьи",
      "heading": "Дубай с детьми",
      "guideTitle": "Как спланировать поездку в Дубай с детьми",
      "guide": [
        {
          "h": "Что подойдёт ребёнку в каком возрасте",
          "p": [
            "С детьми до трёх лет проще всего в океанариуме и в садах цветов: там можно пройти с коляской, в Dubai Aquarium, судя по описаниям туров, дети до двух лет проходят бесплатно, а в Miracle Garden и Butterfly Garden — до трёх.",
            "Дошкольникам больше всего подойдут детские зоны аквапарков и Snow Park в Ski Dubai. Школьникам — парки развлечений вроде IMG Worlds, Legoland и Motiongate или поездка на день в парки острова Яс. Подросткам понравятся гидроцикл и сэндбординг."
          ]
        },
        {
          "h": "Какие ограничения по росту и возрасту проверить",
          "p": [
            "В аквапарках всё решает рост. В Aquaventure, судя по описаниям туров, дети ниже 1,2 м могут быть только в детской зоне Splashers, а в Wild Wadi часть горок — от 1,1 м. На аттракционах парков развлечений тоже есть минимальный рост, поэтому измерьте ребёнка до выбора парка.",
            "В Ski Dubai, судя по описаниям туров, минимальный возраст — два или три года, до 13 лет обязателен шлем, а детям до девяти нужен взрослый рядом; для аттракциона Snow Bullet — от 8 лет, 125 см и 30 кг. Правила зависят от билета и могут меняться, поэтому проверяйте описание перед бронированием."
          ]
        },
        {
          "h": "Сафари и круизы с детьми",
          "p": [
            "В этом списке — парки и билеты на день, у сафари и круизов свои страницы, ссылки на них вверху. Поездку в пустыню выбирайте внимательно: совсем маленьким детям дюн-башинг не рекомендуют. Ищите семейное или эко-сафари с верблюдами и ужином в лагере — или утреннее сафари без позднего вечера. Круиз на доу по Дубай-Крику или в Марине — спокойный вечер для любого возраста."
          ]
        },
        {
          "h": "Советы для поездки в Дубай с детьми",
          "p": [
            "Развлечения на улице планируйте на утро и вечер, а середину дня оставляйте для крытых мест — особенно с мая по сентябрь. Индивидуальные туры позволяют идти в своём темпе, и детское кресло часто можно заказать заранее.",
            "В большинстве развлечений есть детские цены, малыши часто бесплатно. Перед бронированием проверяйте ограничения по возрасту и росту; список отсортирован по отзывам."
          ]
        }
      ],
      "faq": [
        {
          "q": "Куда сходить в Дубае с маленьким ребёнком?",
          "a": "В океанариумы, на спокойные прогулки на лодке, на пляжи с мелкой водой, в крытые игровые зоны и на смотровые площадки. Избегайте дюн-башинга и долгих экскурсий на жаре."
        },
        {
          "q": "Можно ли детям на сафари в пустыне?",
          "a": "Да, если выбрать подходящее: детям постарше дюн-башинг обычно нравится, а семьям с малышами лучше сафари без езды по дюнам или эко-сафари с животными и лагерем."
        },
        {
          "q": "Платят ли дети полную цену за экскурсии в Дубае?",
          "a": "Обычно нет: у большинства туров и достопримечательностей есть детские цены, а совсем маленькие часто бесплатно. Возрастные категории различаются — проверяйте их в описании тура."
        },
        {
          "q": "Когда лучше ехать в Дубай с детьми?",
          "a": "С октября по апрель, когда тепло, но не слишком жарко для пляжа и прогулок. В школьные каникулы много туристов, поэтому популярные билеты бронируйте заранее."
        },
        {
          "q": "Какой рост нужен ребёнку для аквапарков Дубая?",
          "a": "Зависит от парка и горки. В Aquaventure, судя по описаниям туров, дети ниже 1,2 м могут быть только в детской зоне Splashers, а в Wild Wadi часть горок — от 1,1 м. Проверьте описание и измерьте ребёнка перед бронированием."
        },
        {
          "q": "С какого возраста детей пускают в Ski Dubai?",
          "a": "Судя по описаниям туров, с двух или трёх лет, в зависимости от билета. До 13 лет обязателен шлем, детям до девяти нужен взрослый рядом."
        }
      ]
    },
    "day-trips": {
      "title": "Абу-Даби и поездки на день",
      "short": "Поездки\nна день",
      "intro": "Мечеть шейха Зайда и Лувр в Абу-Даби, горы Хатты, фьорды Мусандама — поездки, ради которых стоит уехать из Дубая на целый день.",
      "meta": "Экскурсия в Абу-Даби из Дубая: мечеть шейха Зайда, Лувр Абу-Даби, дворец Каср-аль-Ватан и остров Яс, а также поездки в Хатту и Мусандам.",
      "seoTitle": "Экскурсия в Абу-Даби из Дубая и другие поездки",
      "heading": "Абу-Даби и экскурсии из Дубая на день",
      "guideTitle": "Лучшие поездки из Дубая на день",
      "guide": [
        {
          "h": "Экскурсия в Абу-Даби из Дубая",
          "p": [
            "Столица Эмиратов — примерно в 90 минутах езды и самая популярная поездка из Дубая. Классическая обзорная экскурсия забирает вас из отеля и начинается с мечети шейха Зайда — одной из крупнейших мечетей мира из белого мрамора, с золотом и хрустальными люстрами, — затем Лувр Абу-Даби или президентский дворец Каср-аль-Ватан, набережная Корниш и остановка у отеля Emirates Palace.",
            "Многие туры добавляют остров Яс с Ferrari World, Warner Bros. World и Yas Waterworld — как остановку для фото или с билетами в парк на вторую половину дня. Полный день в Абу-Даби обычно занимает 8–10 часов от отеля до отеля."
          ]
        },
        {
          "h": "Как посетить Большую мечеть",
          "p": [
            "Вход в мечеть шейха Зайда бесплатный, но нужен слот на время посещения — его оформляет организатор тура. Мечеть открыта для туристов каждый день, кроме утра пятницы: в пятницу — только после обеда, туры это учитывают.",
            "Одежда должна быть закрытой: длинные рукава, длинные брюки или юбка до щиколоток, ничего облегающего и просвечивающего, женщинам — платок. В молельных залах снимают обувь. Лувр Абу-Даби по понедельникам закрыт, в этот день туры едут во дворец."
          ]
        },
        {
          "h": "Хатта и горы",
          "p": [
            "Хатта в горах Хаджар у границы с Оманом — полная смена декораций: бирюзовая вода у плотины, каяки, горные велосипеды, тропы для походов и этнодеревня. До неё около 90 минут от Дубая, лучше всего ехать в прохладные месяцы."
          ]
        },
        {
          "h": "Мусандам, Шарджа и восточное побережье",
          "p": [
            "Мусандам в Омане известен фьордами: прогулки на доу среди скал, снорклинг и дельфины. Это долгий день с пересечением границы — возьмите паспорт и проверьте визовые правила для вашего гражданства.",
            "Ближе к Дубаю — Шарджа с лучшими музеями и историческим кварталом региона; восточное побережье у Фуджейры — это пляжи, снорклинг и старые форты."
          ]
        }
      ],
      "faq": [
        {
          "q": "Сколько длится экскурсия в Абу-Даби из Дубая?",
          "a": "Целый день: обычно 8–10 часов вместе с дорогой, около 90 минут в каждую сторону. Туры на полдня включают Большую мечеть и ещё одну остановку."
        },
        {
          "q": "Как одеться в мечеть шейха Зайда?",
          "a": "Одежда должна закрывать руки и ноги, не облегать и не просвечивать, женщинам нужен платок. Без соблюдения дресс-кода внутрь не пустят — проверьте одежду перед выездом."
        },
        {
          "q": "Стоит ли ехать из Дубая в Абу-Даби на день?",
          "a": "Да — для большинства одна мечеть шейха Зайда оправдывает поездку, а тур за один день добавляет Лувр Абу-Даби или остров Яс, и не нужно садиться за руль."
        },
        {
          "q": "Нужен ли паспорт для поездки из Дубая?",
          "a": "Для Мусандама (Оман) — обязательно, там пересекается граница. В поездки по Эмиратам — Абу-Даби, Хатта, Шарджа, Фуджейра — тоже берите паспорт или удостоверение: некоторые туры просят его при посадке."
        },
        {
          "q": "Сколько длятся экскурсии из Дубая?",
          "a": "Большинство — 8–10 часов вместе с трансфером. Поездки в Мусандам из-за дороги и границы часто дольше и начинаются очень рано."
        },
        {
          "q": "Ехать с экскурсией или самому на машине?",
          "a": "По трассам Эмиратов ездить просто, но тур избавляет от парковки и маршрута, включает билеты и гида и — самый простой вариант для Мусандама с его пограничными формальностями."
        }
      ]
    },
    "scenic-flights": {
      "title": "Полёты",
      "short": "Полёты",
      "intro": "Воздушный шар над дюнами на рассвете или вертолёт над Бурдж-Халифой и Пальмой — Дубай с высоты.",
      "meta": "Полёт на воздушном шаре над пустыней Дубая на рассвете и экскурсии на вертолёте над Бурдж-Халифой, Пальмой и Дубай Марина — Дубай с высоты.",
      "seoTitle": "Воздушный шар и вертолёт в Дубае: полёты",
      "heading": "Полёты на воздушном шаре и вертолёте в Дубае",
      "guideTitle": "Дубай с высоты птичьего полёта",
      "guide": [
        {
          "h": "Воздушный шар на рассвете",
          "p": [
            "Шары взлетают над пустыней на рассвете, когда воздух спокойнее всего, и около часа плывут над барханами — с видом на верблюдов, газелей и горы Хаджар на горизонте. Трансфер очень ранний, обычно между 4 и 5 утра, в большинство пакетов входит завтрак в лагере в пустыне, в некоторые — шоу с соколами или поездка на ретро-лендровере.",
            "Полёт зависит от погоды: если ветер слишком сильный, оператор отменяет его и предлагает другую дату или возврат денег."
          ]
        },
        {
          "h": "Вертолётные экскурсии над городом",
          "p": [
            "Полёты на вертолёте начинаются примерно от 12 минут и идут вдоль побережья мимо Бурдж-эль-Араба, Пальмы Джумейра, Атлантиса, Дубай Марина и Бурдж-Халифы. Более долгие маршруты добавляют Дубай-Крик, старый город и острова «Мир».",
            "Места у окна распределяет оператор, часто по весу; частный вертолёт гарантирует вид всей вашей компании."
          ]
        },
        {
          "h": "Что выбрать?",
          "p": [
            "Воздушный шар — это пустыня на рассвете: медленно, тихо и на целое утро. Вертолёт за несколько минут покажет небоскрёбы и побережье и легко впишется в плотный день. Самый красивый свет — у шара ранним утром и у вертолёта ближе к вечеру. Список отсортирован по отзывам."
          ]
        }
      ],
      "faq": [
        {
          "q": "Сколько времени занимает полёт на воздушном шаре в Дубае?",
          "a": "Всё утро: трансфер до рассвета, около часа в воздухе, потом завтрак и программа в лагере, возвращение в отель ближе к полудню."
        },
        {
          "q": "С какого возраста можно на воздушный шар или вертолёт?",
          "a": "На воздушный шар детей обычно берут примерно с 5 лет в сопровождении взрослого, на вертолёт — и младше, вместе со взрослым. Беременным полёт на шаре, как правило, запрещён."
        },
        {
          "q": "Что будет, если полёт на шаре отменят из-за погоды?",
          "a": "Решение принимают утром в день полёта. Если его отменяют из-за ветра или видимости, предлагают другую дату или полный возврат."
        },
        {
          "q": "Когда лучше лететь на воздушном шаре в Дубае?",
          "a": "В прохладные месяцы, с октября по апрель: комфортнее всего и больше всего вылетов. Летом сезон сокращается и вылетов меньше."
        }
      ]
    },
    "hot-air-balloon": {
      "title": "Полёты на воздушном шаре",
      "intro": "Взлёт над пустыней на рассвете и восход солнца над дюнами — спокойный час в воздухе, а потом завтрак в пустынном лагере.",
      "meta": "Полёт на воздушном шаре в Дубае: рассветные полёты над дюнами с трансфером из отеля, завтраком в лагере, соколиной охотой и катанием на верблюдах.",
      "metaFrom": "Полёт на воздушном шаре в Дубае от {{price}}: рассвет над дюнами, трансфер из отеля, завтрак в пустынном лагере, соколиная охота и катание на верблюдах.",
      "seoTitle": "Полёт на воздушном шаре в Дубае на рассвете",
      "heading": "Полёты на воздушном шаре в Дубае",
      "guideTitle": "Как спланировать полёт на воздушном шаре в Дубае",
      "guide": [
        {
          "h": "Как проходит утро",
          "p": [
            "Воздушные шары в Дубае взлетают над пустыней за городом на рассвете, когда воздух спокойнее всего. Трансфер из отеля очень ранний — обычно между 4 и 5 утра, дорога до места старта занимает около часа. Вы смотрите, как надувают шар, садитесь в корзину с пилотом и около часа летите над дюнами, пока небо из синего становится золотым.",
            "После посадки в большинстве программ продолжение на земле: завтрак в пустынном лагере, часто шоу с соколами, иногда катание на верблюде или поездка на ретро-лендровере. В отель обычно возвращаются ближе к полудню."
          ]
        },
        {
          "h": "Стандартная, премиум или отдельная корзина",
          "p": [
            "В стандартном полёте вы делите большую корзину, разделённую на отсеки, с другими гостями. Премиум-программы — это группа поменьше, завтрак получше или дополнения вроде соколиной охоты и поездки по пустыне; отдельная корзина бронируется только для вашей компании — хороший вариант для предложения руки и сердца или годовщины.",
            "Некоторые программы совмещают полёт с дюн-башингом или квадроциклом, а часть полётов стартует в Рас-эль-Хайме, примерно в часе езды севернее. В описании каждого предложения указано, что входит в стоимость и есть ли трансфер из отеля."
          ]
        },
        {
          "h": "Погода, сезон и что взять с собой",
          "p": [
            "Шары летают только в безветренную погоду. Пилот принимает решение утром в день полёта; если ветер или видимость не позволяют лететь, вам предложат другую дату или вернут деньги. Основной сезон — с октября по апрель, летом полётов меньше.",
            "Утром в пустыне прохладно, даже если днём жарко: возьмите лёгкую куртку, наденьте закрытую обувь и держите камеру под рукой. Список отсортирован по отзывам путешественников."
          ]
        }
      ],
      "faq": [
        {
          "q": "Сколько стоит полёт на воздушном шаре в Дубае?",
          "a": "Место в общей корзине с завтраком — базовая цена; премиум-пакеты с корзиной поменьше, соколиной охотой или поездкой по пустыне дороже, отдельная корзина для вашей компании — дороже всего. Актуальная цена за человека — на каждой карточке."
        },
        {
          "q": "Сколько длится полёт на воздушном шаре в Дубае?",
          "a": "Около часа в воздухе. С ранним трансфером, подготовкой шара, завтраком и дорогой обратно поездка занимает всё утро — примерно с 4–5 утра до позднего утра."
        },
        {
          "q": "Во сколько начинается полёт?",
          "a": "На рассвете, поэтому время меняется в зависимости от сезона. Трансфер из отеля обычно между 4 и 5 утра; точное время организатор подтверждает накануне."
        },
        {
          "q": "Можно ли лететь на воздушном шаре с детьми?",
          "a": "Обычно с 5 лет, на некоторых полётах с 7, и только со взрослым. Беременным и людям с проблемами спины или сердца лететь не рекомендуют — условия оператора указаны в описании."
        },
        {
          "q": "Что будет, если полёт отменят?",
          "a": "Если пилот отменяет полёт из-за ветра или видимости, вам предложат другую дату или вернут деньги. Поэтому полёт лучше бронировать в начале поездки, оставив свободное утро в запасе."
        },
        {
          "q": "Откуда взлетают воздушные шары в Дубае?",
          "a": "Из пустыни в глубине эмирата, примерно в часе езды от города. Площадка зависит от ветра в этот день, поэтому трансфер из отеля входит в пакет. Несколько полётов — из Рас-эль-Хаймы, севернее."
        },
        {
          "q": "Бывают ли полёты на закате или над городом?",
          "a": "Нет: свободные воздушные шары взлетают только на рассвете, пока дневная жара не подняла ветер, и летают над пустыней, вдали от города. Шар на Пальме или дешёвый билет на «воздушный шар» — это привязной аэростат: короткий подъём и спуск на тросе, а не полёт над пустыней."
        },
        {
          "q": "Есть ли ограничение по весу?",
          "a": "Да, обычно около 118–119 кг на пассажира. Некоторые операторы за пассажира тяжелее берут цену второго места — проверьте описание перед бронированием."
        }
      ]
    },
    "helicopter-tour": {
      "title": "Вертолётные экскурсии",
      "intro": "Пальма Джумейра, Бурдж-эль-Араб и Бурдж-Халифа с высоты — короткий полёт вдоль побережья, от 12 минут.",
      "meta": "Полёт на вертолёте в Дубае: экскурсии от Atlantis The Palm над Пальмой Джумейра, Бурдж-эль-Араб, Дубай Марина и Бурдж-Халифа — в группе или индивидуально.",
      "metaFrom": "Полёт на вертолёте в Дубае от {{price}}: экскурсии от Atlantis The Palm над Пальмой Джумейра, Бурдж-эль-Араб, Дубай Марина и Бурдж-Халифа — в группе или индивидуально.",
      "seoTitle": "Полёт на вертолёте в Дубае: экскурсии над городом",
      "heading": "Вертолётные экскурсии в Дубае",
      "guideTitle": "Как спланировать полёт на вертолёте в Дубае",
      "guide": [
        {
          "h": "Маршруты и сколько длится полёт",
          "p": [
            "Большинство вертолётных экскурсий в Дубае вылетают с вертолётной площадки Atlantis The Palm на краю Пальмы Джумейра; другие — с площадки в районе Джумейра рядом с Mall of the Emirates или от Jumeirah Beach Residence. Стандартный полёт длится 12 минут: над островом-пальмой, вдоль берега мимо Бурдж-эль-Араб к Бурдж-Халифе и обратно.",
            "Полёты подольше — в зависимости от компании 15, 17, 25 минут и до часа — добавляют Дубай Марину, острова «Мир», шоссе Шейха Зайда и залив Дубай-Крик, с которого начинался старый город. Минуты — это время в воздухе; с регистрацией, инструктажем и трансфером закладывайте два-три часа."
          ]
        },
        {
          "h": "Групповой или индивидуальный полёт и комбо",
          "p": [
            "В групповом полёте вы летите с другими гостями, обычно по пять-шесть человек в вертолёте, а места распределяет оператор — часто по весу, так что место у окна не гарантировано. Индивидуальный полёт бронируется только для вашей компании, маршрут и время выбираете вы — хороший вариант для предложения руки и сердца, дня рождения или съёмки.",
            "Некоторые программы совмещают полёт с вечерним сафари в пустыне или ужином в Atlantis The Palm, другие включают трансфер из отеля и обратно. В описании каждого предложения указано, откуда вылет, сколько длится полёт и что входит в стоимость."
          ]
        },
        {
          "h": "Что нужно знать перед полётом",
          "p": [
            "Возьмите паспорт или Emirates ID: документ проверяют на площадке, без него на борт не пустят. Приезжайте за 30–45 минут. Сумки и незакреплённые вещи остаются на земле — на площадках есть шкафчики, — а телефон и камеру взять с собой можно.",
            "Полёты зависят от погоды: если ветер, пыль или плохая видимость не позволяют лететь, вам предложат другое время или вернут деньги. Самый прозрачный воздух — в прохладные месяцы, с октября по апрель, а самый тёплый свет над небоскрёбами — ближе к вечеру. Список отсортирован по отзывам путешественников."
          ]
        }
      ],
      "faq": [
        {
          "q": "Сколько длится полёт на вертолёте в Дубае?",
          "a": "Стандартный полёт — 12 минут в воздухе, длинные маршруты — примерно от 15 минут до часа. С регистрацией, инструктажем и трансфером вся поездка занимает два-три часа."
        },
        {
          "q": "Сколько стоит полёт на вертолёте в Дубае?",
          "a": "Цена зависит от минут в воздухе: 12-минутный полёт над Пальмой и Бурдж-эль-Арабом — самый доступный, длинные маршруты к Бурдж-Халифе и Крику дороже, а индивидуальный полёт оплачивается за весь вертолёт. Актуальная цена — на каждой карточке."
        },
        {
          "q": "Откуда вылетают вертолёты в Дубае?",
          "a": "Чаще всего с вертолётной площадки Atlantis The Palm на Пальме Джумейра. Некоторые компании летают с площадки в Джумейре рядом с Mall of the Emirates или от Jumeirah Beach Residence — место старта и наличие трансфера указаны в описании."
        },
        {
          "q": "Что взять с собой?",
          "a": "Оригинал паспорта или Emirates ID — его проверяют перед посадкой. Сумки оставляют в шкафчике на площадке, телефон или камеру можно взять с собой."
        },
        {
          "q": "Есть ли ограничение по весу?",
          "a": "Да, обычно около 110–113 кг на пассажира. Пассажиров взвешивают на регистрации, и пассажиру тяжелее может понадобиться второе место."
        },
        {
          "q": "Можно ли лететь на вертолёте с детьми?",
          "a": "Да, с 2 лет и со взрослым — детей младше большинство операторов не берёт, а с 2 лет обычно действует взрослый тариф. Каждому пассажиру, в том числе ребёнку, нужен свой документ. Условия оператора указаны в описании."
        },
        {
          "q": "Вертолёт или воздушный шар?",
          "a": "Вертолёт за несколько минут показывает небоскрёбы и побережье и легко вписывается в любой день. Шар летит над пустыней на рассвете и занимает всё утро — смотрите полёты на воздушном шаре."
        }
      ]
    },
    "quad-biking": {
      "title": "Квадроциклы и багги",
      "intro": "Сами за рулём в красных дюнах за Дубаем — на квадроцикле или багги, отдельной поездкой или в составе сафари в пустыне.",
      "meta": "Квадроциклы и багги в Дубае: поездки за рулём по красным дюнам, утреннее и вечернее сафари с квадроциклом, катанием на верблюдах и ужином-барбекю.",
      "metaFrom": "Квадроциклы и багги в Дубае от {{price}}: поездки за рулём по красным дюнам, утреннее и вечернее сафари с квадроциклом, верблюдами и ужином-барбекю.",
      "seoTitle": "Квадроциклы и багги в Дубае: сами за рулём в пустыне",
      "heading": "Квадроциклы и багги в Дубае",
      "guideTitle": "Как выбрать поездку на квадроцикле или багги",
      "guide": [
        {
          "h": "Квадроцикл или багги?",
          "p": [
            "Квадроцикл (ATV) — одноместная машина, которой управляют как мотоциклом, с газом под большим пальцем: осваивается за пару минут и отлично подходит для небольших дюн. Багги — машина с каркасом безопасности и ремнями на двоих или четверых; она берёт дюны покруче и подходит парам и семьям, которые хотят ехать вместе.",
            "В обоих случаях за рулём вы сами: гид ведёт группу по проложенному маршруту и подстраивает темп под самого неопытного водителя. Шлемы и защитные очки выдают на месте."
          ]
        },
        {
          "h": "Отдельно или вместе с сафари",
          "p": [
            "Многие туры добавляют квадроцикл к классическому сафари в пустыне: дюн-башинг на внедорожнике, катание на верблюде, сэндбординг, а вечером — лагерь с ужином-барбекю и шоу. Другие — отдельные утренние поездки от 30 минут до двух часов, когда песок ещё прохладный, а свет мягкий.",
            "Катаются в красных дюнах к юго-востоку от города, в районе Лахбаба и Аль-Бадайера, примерно в 45 минутах от Дубая. Трансфер из отеля входит в большинство туров; сколько времени вы будете за рулём, указано в описании."
          ]
        },
        {
          "h": "Перед бронированием",
          "p": [
            "Организаторы устанавливают минимальный возраст водителя — часто 16 лет для квадроцикла и 18 для багги; детей помладше обычно сажают пассажирами в багги. Наденьте закрытую обувь и удобную одежду, которую не жалко запачкать песком, и возьмите платок от пыли.",
            "Утренние поездки прохладнее и лучше всего подходят с мая по сентябрь; зимой популярнее вечерние сафари с остановкой на закат. Список отсортирован по отзывам путешественников."
          ]
        }
      ],
      "faq": [
        {
          "q": "Нужны ли права, чтобы кататься на квадроцикле в Дубае?",
          "a": "Для поездки с гидом по пустыне обычно нет, но есть минимальный возраст — часто 16 лет. Водителям багги, как правило, должно быть не меньше 18. Условия организатора указаны в описании."
        },
        {
          "q": "С какого возраста можно кататься на квадроцикле в Дубае?",
          "a": "Зависит от оператора: некоторые дают детям с 10–13 лет квадроцикл поменьше и с гидом, у большинства взрослый квадроцикл — с 16 лет, водитель багги — обычно с 18. Детям помладше можно пассажиром в багги. Ограничение указано в описании."
        },
        {
          "q": "Сколько стоит покататься на квадроцикле или багги?",
          "a": "Дешевле всего — сафари с короткой поездкой на квадроцикле; отдельный час на квадроцикле или багги дороже, а багги оплачивается за машину. У многих сафари квадроцикл — опция: проверьте, входит ли он или доплачивается."
        },
        {
          "q": "Сколько длится поездка на квадроцикле?",
          "a": "Зависит от тура: в сафари с квадроциклом обычно 20–30 минут за рулём, в отдельных турах на квадроциклах и багги — один-два часа. Длительность указана в описании."
        },
        {
          "q": "Подходит ли квадроцикл новичкам?",
          "a": "Да, маршрут ведёт гид: сначала он объясняет управление, потом задаёт темп. Шлемы и очки выдают. Если не хочется ехать одному, выберите двухместный багги."
        },
        {
          "q": "Когда лучше кататься — утром или вечером?",
          "a": "Утром прохладнее и спокойнее, это лучший выбор в жаркие месяцы. Вечерние поездки обычно совмещают с сафари, закатом и ужином в лагере."
        },
        {
          "q": "Можно ли взять квадроцикл в аренду и кататься самому?",
          "a": "За рулём вы сами, но не в одиночку: в пустыне группу всегда ведёт гид по маршруту. В индивидуальном туре у вашей компании свой гид и свой темп."
        },
        {
          "q": "Где катаются на квадроциклах и багги в Дубае?",
          "a": "В красных дюнах у Лахбаба и Аль-Бадайера, примерно в 45 минутах к юго-востоку от города. Почти все туры включают трансфер из отеля."
        }
      ]
    },
    "morning-desert-safari": {
      "title": "Утреннее сафари в пустыне",
      "intro": "Красные дюны в утренней прохладе — джиппинг по барханам, сэндбординг, катание на верблюде или квадроцикле, и к обеду обратно в городе.",
      "meta": "Утреннее сафари в пустыне в Дубае: трансфер из отеля на рассвете, джиппинг по красным дюнам, сэндбординг, верблюды и квадроциклы, возвращение к обеду.",
      "metaFrom": "Утреннее сафари в Дубае от {{price}}: трансфер из отеля на рассвете, джиппинг по красным дюнам, сэндбординг, верблюды и квадроциклы, возвращение к обеду.",
      "seoTitle": "Утреннее сафари в Дубае: дюны, верблюды, квадроциклы",
      "heading": "Утреннее сафари в пустыне в Дубае",
      "guideTitle": "Как спланировать утреннее сафари",
      "guide": [
        {
          "h": "Как проходит утро",
          "p": [
            "Утреннее сафари начинается с трансфера из отеля около 7–8 утра и примерно 45 минут дороги до красных дюн к юго-востоку от города, в районе Лахбаба. Там водитель спускает шины и ведёт внедорожник по барханам — это и есть джиппинг, или дюн-башинг, — с остановками для фото на гребнях.",
            "Дальше — развлечения: спуск с дюны на сэндборде, короткая прогулка на верблюде и во многих турах катание на квадроцикле или багги за рулём. Большинство поездок длится три-пять часов, так что к обеду или в начале дня вы уже в отеле."
          ]
        },
        {
          "h": "Утром или вечером?",
          "p": [
            "Утром прохладнее, на дюнах меньше людей, а низкое солнце подчёркивает рябь на песке — лучший свет для фото после рассвета. Утро подходит тем, у кого планы на вечер, семьям с маленькими детьми, которые рано ложатся, и всем, кто улетает ночью.",
            "Чего утром нет, так это лагеря: ни ужина-барбекю, ни огненного шоу и танцев танура, ни заката. В одних турах дают воду и напитки, в некоторых — лёгкий завтрак. Мягкий вариант — исторические сафари на ретро-автомобиле в оазис Аль-Мармум: меньше джиппинга, больше дикой природы."
          ]
        },
        {
          "h": "Практические советы",
          "p": [
            "Надевайте лёгкую закрытую одежду и закрытую обувь, возьмите солнечные очки, крем от солнца и головной убор: песок быстро нагревается, когда солнце поднимается. С мая по сентябрь жарко уже к середине утра, поэтому выбирайте самый ранний трансфер; с октября по апрель приятно всё утро.",
            "Джиппинг — это тряска, он не подходит беременным и людям с проблемами спины или шеи, а для квадроциклов есть минимальный возраст — проверьте описание. Туры бывают групповые и индивидуальные; что входит, указано в каждом предложении, а список отсортирован по отзывам путешественников."
          ]
        }
      ],
      "faq": [
        {
          "q": "Во сколько начинается утреннее сафари?",
          "a": "Трансфер из отеля обычно между 7:00 и 8:30, летом раньше. С дорогой туда и обратно большинство туров заканчивается между 11:00 и 13:00."
        },
        {
          "q": "Что входит в утреннее сафари?",
          "a": "Обычно трансфер из отеля, джиппинг на внедорожнике, сэндбординг и короткая прогулка на верблюде, плюс вода или напитки. Квадроциклы и багги в одних турах включены, в других — за доплату; это указано в описании."
        },
        {
          "q": "Что лучше — утреннее или вечернее сафари?",
          "a": "Утром прохладнее, спокойнее и лучше для фото, а вечер остаётся свободным. Вечером добавляются закат и лагерь с барбекю и шоу. Утро — ради дюн, вечер — ради лагеря."
        },
        {
          "q": "Подходит ли утреннее сафари для детей?",
          "a": "Да — оно короче и прохладнее вечернего, а детям нравятся сэндбординг и верблюды. Для джиппинга в некоторых турах есть возрастное ограничение, квадроциклы обычно с 16 лет; проверьте описание."
        },
        {
          "q": "Проводят ли утреннее сафари летом?",
          "a": "Да, круглый год. С июня по сентябрь выбирайте самый ранний выезд: к середине утра песок раскаляется и в дюнах тяжело. С октября по апрель приятно всё утро."
        },
        {
          "q": "Можно ли совместить утреннее сафари с воздушным шаром?",
          "a": "Да: в некоторых пакетах с воздушным шаром после завтрака есть джиппинг или квадроцикл, так что рассветный полёт и дюны помещаются в одно утро. Они — среди полётов на воздушном шаре."
        }
      ]
    },
    "burj-khalifa": {
      "title": "Билеты на Бурдж-Халифа",
      "intro": "At the Top на 124-м и 125-м этажах, SKY на 148-м и The Lounge ещё выше — билеты на самое высокое здание мира, отдельно или вместе с обзорной экскурсией.",
      "meta": "Билеты на Бурдж-Халифа: At the Top на 124–125 этажах, At the Top SKY на 148-м и The Lounge на 152–154, а также комбо с Dubai Aquarium и экскурсиями по городу.",
      "seoTitle": "Билеты на Бурдж-Халифа: At the Top, SKY и The Lounge",
      "heading": "Билеты на Бурдж-Халифа и At the Top",
      "guideTitle": "Как спланировать подъём на Бурдж-Халифа",
      "guide": [
        {
          "h": "Какой этаж выбрать",
          "p": [
            "Высота Бурдж-Халифа — 828 метров, и посетители могут подняться на три уровня. At the Top на 124-м и 125-м этажах — главная смотровая площадка: обзор на 360 градусов над Даунтауном, заливом и пустыней, с открытой террасой на 124-м этаже. At the Top SKY на 148-м этаже выше и спокойнее, с лаунжем для гостей и небольшими группами; в билет входят и 124-й со 125-м.",
            "The Lounge на 152–154 этажах — самый высокий из трёх уровней: скорее лаунж с напитками и лёгкими закусками, чем смотровая площадка, и самый эксклюзивный способ подняться на башню."
          ]
        },
        {
          "h": "Закат, день или ночь",
          "p": [
            "Билеты продаются на определённое время. Самые популярные слоты — около заката: город становится золотым, а потом загораются огни, — и раскупают их первыми, часто за несколько дней. Днём в ясную погоду виднее всего побережье и пустыня; после темноты — огни Шейх-Зайед-роуд и Марины.",
            "Наверху закладывайте час–полтора, плюс досмотр и очередь к лифтам. Летом вид может смазывать дымка; самые ясные дни обычно бывают зимой."
          ]
        },
        {
          "h": "Как добраться и что совместить",
          "p": [
            "Вход на At the Top — на нижнем этаже (Lower Ground) торгового центра The Dubai Mall, который крытым переходом соединён со станцией метро Burj Khalifa/Dubai Mall. После подъёма, вечером, на озере у подножия башни идёт шоу поющих фонтанов Дубая.",
            "Многие билеты продаются комбо — с Dubai Aquarium & Underwater Zoo в том же ТЦ, с Dubai Frame, Miracle Garden или с экскурсией по городу на полдня или целый день с трансфером из отеля. Какие этажи и дополнения входят, указано в описании. Список отсортирован по отзывам путешественников."
          ]
        }
      ],
      "faq": [
        {
          "q": "Какой билет на Бурдж-Халифа выбрать?",
          "a": "Большинству подойдёт At the Top на 124-м и 125-м этажах — классический вид и больше всего свободного времени для входа. At the Top SKY на 148-м этаже выше и свободнее; The Lounge на 152–154 этажах добавляет напитки и самый высокий вид, открытый для посетителей."
        },
        {
          "q": "Когда лучше подниматься на Бурдж-Халифа?",
          "a": "Незадолго до заката, если удастся взять этот слот: за один подъём вы увидите город днём, на закате и в ночных огнях. Такие слоты раскупают первыми, поэтому бронируйте за несколько дней; меньше всего людей рано утром."
        },
        {
          "q": "Сколько длится посещение At the Top?",
          "a": "Наверху — час–полтора, плюс досмотр и лифты: в целом закладывайте два часа. Комбо с экскурсией по городу займёт полдня или целый день."
        },
        {
          "q": "Где вход на Бурдж-Халифа?",
          "a": "На нижнем этаже (Lower Ground) The Dubai Mall, по указателям At the Top. На метро — до станции Burj Khalifa/Dubai Mall; билеты с трансфером довезут от отеля прямо ко входу."
        }
      ]
    },
    "dubai-frame": {
      "title": "Билеты в Dubai Frame",
      "intro": "Рамка высотой 150 метров в парке Забиль со стеклянным полом на мосту наверху — с одной стороны старый Дубай, с другой новые небоскрёбы.",
      "meta": "Билеты в Dubai Frame: мост со стеклянным полом на высоте 150 м над парком Забиль, с трансфером из отеля или в комбо с Бурдж-Халифа и Miracle Garden.",
      "seoTitle": "Dubai Frame: билеты на стеклянный мост и комбо",
      "heading": "Билеты в Dubai Frame",
      "guideTitle": "Как спланировать визит в Dubai Frame",
      "guide": [
        {
          "h": "Что вы увидите",
          "p": [
            "Dubai Frame высотой 150 метров стоит в парке Забиль, между старыми районами и новым городом, и похож на гигантскую рамку для картины. Лифт поднимает на мост, соединяющий две его башни; часть пола там стеклянная. На севере видны Дейра, Бур-Дубай и залив Крик, на юге — Шейх-Зайед-роуд и Бурдж-Халифа.",
            "Визит начинается с галереи о прошлом Дубая и заканчивается небольшой выставкой о будущем города — так что Dubai Frame не только показывает город, но и рассказывает его историю."
          ]
        },
        {
          "h": "Когда идти и сколько времени закладывать",
          "p": [
            "Закладывайте час–полтора. Хорошее время — ближе к вечеру: сначала вы видите город при дневном свете, а с закатом загораются огни. Утром, сразу после открытия, людей меньше всего.",
            "Вход — по времени, и в выходные и в прохладные месяцы, главный сезон, у лифта собираются очереди: бронь заранее избавит от ожидания."
          ]
        },
        {
          "h": "Билеты с трансфером и комбо",
          "p": [
            "От ближайшей станции метро до Dubai Frame идти довольно далеко, поэтому во многие билеты входит трансфер из отеля и обратно. Другие совмещают его с Бурдж-Халифа, Miracle Garden, Global Village или AYA Universe либо с вечерней прогулкой на дау — целый день достопримечательностей в одной брони.",
            "Miracle Garden и Global Village работают только в прохладные месяцы, примерно с осени до весны, так что комбо с ними сезонные. Что входит в билет, указано в описании. Список отсортирован по отзывам путешественников."
          ]
        }
      ],
      "faq": [
        {
          "q": "Какой высоты Dubai Frame?",
          "a": "150 метров. Смотровой мост наверху соединяет две башни, и по участку со стеклянным полом можно пройти."
        },
        {
          "q": "Сколько длится посещение Dubai Frame?",
          "a": "Около часа–полутора: галерея в начале, мост наверху и выставка на выходе."
        },
        {
          "q": "Бурдж-Халифа или Dubai Frame?",
          "a": "Они показывают разное: с Бурдж-Халифа весь город виден с гораздо большей высоты, а Dubai Frame ставит рядом старый и новый Дубай с высоты 150 метров — и людей там обычно меньше. С комбо-билетом можно успеть и туда, и туда за один день."
        },
        {
          "q": "Как добраться до Dubai Frame?",
          "a": "Он стоит в парке Забиль, между Бур-Дубаем и Даунтауном. Удобнее всего на такси или с билетом, в который входит трансфер; от ближайших станций метро — 15–20 минут пешком."
        }
      ]
    },
    "aquaventure": {
      "title": "Аквапарк Aquaventure",
      "intro": "Аквапарк отеля Atlantis The Palm: рекордные горки через лагуну с акулами, длинная ленивая река, искусственная волна и собственный пляж.",
      "meta": "Билеты в Aquaventure в Atlantis The Palm: дневные билеты в крупнейший аквапарк Дубая, комбо с аквариумом Lost Chambers, трансфер из отеля и встречи с акулами.",
      "seoTitle": "Aquaventure Дубай: билеты в аквапарк Atlantis",
      "heading": "Билеты в аквапарк Aquaventure",
      "guideTitle": "Как спланировать день в Aquaventure",
      "guide": [
        {
          "h": "Что есть в аквапарке",
          "p": [
            "Aquaventure — аквапарк отеля Atlantis The Palm на внешней оконечности Пальмы Джумейра и один из крупнейших в мире: больше 100 горок и аттракционов. Самые известные — Leap of Faith, почти отвесный спуск через лагуну с акулами, Poseidon's Revenge и Aquaconda, одна из самых больших водных горок в мире.",
            "Между горками — длинная ленивая река с порогами, искусственная волна для сёрфинга, зоны для малышей и собственный пляж; всё это входит в дневной билет."
          ]
        },
        {
          "h": "Дневной билет, комбо и доплаты",
          "p": [
            "Дневной билет даёт доступ к горкам, реке и пляжу. Комбо-билеты добавляют аквариум Lost Chambers в Atlantis с аквариумами в декорациях затонувшего города; в другие входит трансфер из отеля, обед или встреча с акулами или дельфинами.",
            "Fast-track, шкафчики, полотенца и кабаны обычно оплачиваются отдельно. Что входит в билет и какой вариант вы бронируете, указано в описании."
          ]
        },
        {
          "h": "Советы на день",
          "p": [
            "Закладывайте целый день и приезжайте к открытию — тогда очереди на большие горки самые короткие. Аквапарк работает круглый год; летом комфортнее всего утром и ближе к вечеру.",
            "На некоторых горках есть ограничения по росту — проверьте их, прежде чем обещать детям покататься. Монорельс Palm Monorail идёт до конечной станции Atlantis Aquaventure прямо у аквапарка; билеты с трансфером заберут вас из отеля. Список отсортирован по отзывам путешественников."
          ]
        }
      ],
      "faq": [
        {
          "q": "Входит ли аквариум Lost Chambers в билет Aquaventure?",
          "a": "В обычный дневной билет — нет: для обоих берите комбо-билет. Какой вариант вы бронируете, указано в описании."
        },
        {
          "q": "Как добраться до Aquaventure?",
          "a": "Аквапарк находится в Atlantis The Palm, в конце Пальмы Джумейра. Монорельс Palm Monorail идёт до станции Atlantis Aquaventure; такси или билет с трансфером довезут прямо ко входу."
        },
        {
          "q": "Подходит ли Aquaventure для маленьких детей?",
          "a": "Да: для малышей есть детские зоны и пологие горки, а спасательные жилеты выдают в аквапарке. На большие горки действуют ограничения по росту, так что младших детей на них могут не пустить."
        },
        {
          "q": "Пляж входит в билет?",
          "a": "Да, дневной билет включает собственный пляж аквапарка — между горками можно искупаться в море."
        }
      ]
    },
    "miracle-garden": {
      "title": "Билеты в Miracle Garden",
      "intro": "Самый большой в мире сад живых цветов — арки, замки и Airbus A380 Emirates из цветов. Работает только в прохладные месяцы.",
      "meta": "Билеты в Dubai Miracle Garden: вход с трансфером из отеля или без, комбо с Dubai Frame, Бурдж-Халифой, Global Village и Садом бабочек.",
      "seoTitle": "Dubai Miracle Garden: билеты в сад цветов",
      "heading": "Билеты в Dubai Miracle Garden",
      "guideTitle": "Как спланировать поездку в Dubai Miracle Garden",
      "guide": [
        {
          "h": "Что там посмотреть",
          "p": [
            "Dubai Miracle Garden в районе Dubailand — самый большой в мире сад живых цветов: около 150 миллионов цветов на 72 000 квадратных метров, сложенных в арки-сердца, аллеи под разноцветными зонтиками, цветочные замки и фигуры в натуральную величину. Главный экспонат — Airbus A380 Emirates в полный размер, целиком покрытый цветами и занесённый в Книгу рекордов Гиннесса.",
            "Композиции каждый сезон делают заново, так что и во второй раз вы увидите новые темы. Дорожки ровные, частично в тени, есть кафе, скамейки и туалеты; чтобы обойти весь сад, хватит двух-трёх часов."
          ]
        },
        {
          "h": "Сад работает по сезону",
          "p": [
            "Сад под открытым небом и открыт только в прохладные месяцы: обычно он открывается осенью, примерно в октябре или ноябре, и закрывается с приходом летней жары, примерно в мае или июне, — точные даты объявляют каждый год. Вне сезона он закрыт, поэтому проверьте даты перед покупкой.",
            "Работает ежедневно с утра до вечера, в выходные — дольше. Удобнее всего приезжать ближе к вечеру: прохладнее, мягкий свет для фото, а после заката сад подсвечивают."
          ]
        },
        {
          "h": "Билеты, трансфер и комбо",
          "p": [
            "Достаточно входного билета; во многие предложения включён трансфер из отеля — это удобно, потому что рядом с садом нет метро, а на такси от Даунтауна или Марины около 20–30 минут. Билеты без очереди экономят время у входа в загруженные вечера выходных.",
            "Примерно половина билетов — комбо: с соседним Садом бабочек, Dubai Frame, смотровой площадкой At the Top на Бурдж-Халифе или вечером в Global Village, который работает в тот же сезон. В описании каждого предложения указано, что входит в стоимость. Список отсортирован по отзывам путешественников."
          ]
        }
      ],
      "faq": [
        {
          "q": "Когда работает Dubai Miracle Garden?",
          "a": "Только в прохладные месяцы: обычно открывается примерно в октябре или ноябре и закрывается примерно в мае или июне, точные даты объявляют каждый сезон. Работает ежедневно с утра до вечера, в выходные — дольше."
        },
        {
          "q": "Сколько времени нужно на Miracle Garden?",
          "a": "Два-три часа, чтобы обойти весь сад. Вместе с соседним Садом бабочек закладывайте полдня."
        },
        {
          "q": "Как добраться до Dubai Miracle Garden?",
          "a": "Сад находится в Dubailand, на такси около 20–30 минут от Даунтауна или Дубай Марины, метро рядом нет. Во многие билеты включён трансфер из отеля — это указано в описании."
        },
        {
          "q": "Входит ли Сад бабочек в билет?",
          "a": "В обычный билет в Miracle Garden — нет: это отдельная достопримечательность по соседству. Комбо-билеты включают оба сада — ищите «Butterfly Garden» в названии."
        }
      ]
    },
    "global-village": {
      "title": "Global Village в Дубае",
      "intro": "Сезонный фестивальный парк под открытым небом: павильоны разных стран, уличная еда со всего мира, шоу на сценах и парк аттракционов. Работает в прохладные месяцы, с вечера до поздней ночи.",
      "meta": "Global Village в Дубае: что посмотреть, когда открыт, как добраться, входные билеты с трансфером из отеля или в комбо с Miracle Garden.",
      "seoTitle": "Global Village в Дубае: как посетить, часы работы, билеты",
      "heading": "Global Village в Дубае",
      "guideTitle": "Как спланировать вечер в Global Village",
      "guide": [
        {
          "h": "Что такое Global Village",
          "p": [
            "Global Village — большой фестивальный парк под открытым небом в районе Dubailand, на окраине города. Около тридцати павильонов, каждый в архитектурном стиле своей страны или региона, продают ремесленные изделия, сладости, специи, ткани и сувениры примерно 90 культур — от Турции, Индии и Марокко до Китая, Африки и стран Залива.",
            "Между павильонами — сотни киосков с едой и ресторанов, главная сцена и сцены поменьше с музыкальными и танцевальными шоу, озеро с представлениями на воде и Carnaval — парк аттракционов, за которые платят отдельно от входа. По вечерам в выходные бывает фейерверк."
          ]
        },
        {
          "h": "Когда работает",
          "p": [
            "Global Village — зимнее развлечение: сезон обычно открывается в октябре и длится примерно до начала мая, точные даты объявляют каждый год. Летом парк закрыт.",
            "Открывается ближе к вечеру и работает примерно до полуночи, в выходные — дольше. Большинство приезжает к закату, когда становится прохладнее и павильоны подсвечивают; в будни вечером заметно свободнее, чем в пятницу и субботу. Закладывайте три-четыре часа — больше, если хотите покататься на аттракционах и поужинать в ресторане."
          ]
        },
        {
          "h": "Как добраться и какие билеты",
          "p": [
            "Парк находится у шоссе Sheikh Mohammed Bin Zayed Road, на такси около 25–30 минут от Даунтауна и чуть дольше от Дубай Марины. Метро рядом нет; от нескольких станций метро ходят городские автобусы, есть большая парковка. Во многие предложения ниже включён трансфер из отеля — не придётся искать такси вечером.",
            "Входные билеты бывают подешевле — на будние дни — и на любой день; маленькие дети проходят бесплатно. Аттракционы, игры и еду оплачивают внутри. Miracle Garden тоже находится в Dubailand, недалеко, и работает в тот же сезон, поэтому в нескольких предложениях они объединены: днём сад, вечером Global Village. В описании каждого предложения указано, что входит в стоимость; список отсортирован по отзывам путешественников."
          ]
        }
      ],
      "faq": [
        {
          "q": "Когда работает Global Village?",
          "a": "В прохладные месяцы: сезон обычно длится с октября примерно до начала мая, даты объявляют каждый год. Парк открыт ежедневно с вечера примерно до полуночи, в выходные — дольше."
        },
        {
          "q": "Сколько времени нужно на Global Village?",
          "a": "Три-четыре часа, чтобы обойти павильоны, поесть и посмотреть шоу; с аттракционами Carnaval — полдня и больше."
        },
        {
          "q": "Как добраться до Global Village?",
          "a": "Парк находится в Dubailand, на такси около 25–30 минут от Даунтауна, метро рядом нет. От нескольких станций метро ходят городские автобусы, а во многие билеты включён трансфер из отеля — это указано в описании."
        },
        {
          "q": "Входят ли аттракционы в билет?",
          "a": "Нет. Вход даёт доступ к павильонам, шоу и фейерверку; аттракционы и игры Carnaval оплачиваются отдельно внутри парка."
        },
        {
          "q": "Можно ли за один день посетить Global Village и Miracle Garden?",
          "a": "Да: оба в Dubailand, недалеко друг от друга, и работают в один сезон. Днём — Miracle Garden, после заката — Global Village; комбо-билеты включают оба."
        }
      ]
    },
    "ski-dubai": {
      "title": "Билеты в Ski Dubai",
      "intro": "Настоящий снег и минусовая температура посреди торгового центра — снежный парк, кресельный подъёмник, склон и колония пингвинов, круглый год.",
      "meta": "Билеты в Ski Dubai: снежный парк на весь день с зимней одеждой, подъёмником и аттракционами, пингвины и крытый склон в Mall of the Emirates.",
      "seoTitle": "Ski Dubai: билеты в снежный парк и на склон",
      "heading": "Билеты в Ski Dubai",
      "guideTitle": "Как спланировать день в Ski Dubai",
      "guide": [
        {
          "h": "Снег посреди пустыни",
          "p": [
            "Ski Dubai — крытый горнолыжный курорт в Mall of the Emirates, первый на Ближнем Востоке: круглый год здесь около −1…−2 °C и 6000 тонн настоящего снега. Склон длиной около 400 метров обслуживают кресельный подъёмник и бугель, есть фристайл-зона с трамплинами и рампами.",
            "Большинство приезжает в снежный парк рядом со склоном: трассы для санок и тюбинга, снежная пещера, катание в гигантских шарах, аттракцион Mountain Thriller и игра в снежки. Здесь же живёт колония субантарктических и королевских пингвинов; «Марш пингвинов» несколько раз в день бесплатен для гостей снежного парка."
          ]
        },
        {
          "h": "Какой билет выбрать",
          "p": [
            "Билет Snow Park — это доступ в парк на весь день с зимней одеждой (куртка, брюки, ботинки и носки) и обычно одна поездка на кресельном подъёмнике и одна на Mountain Thriller. Билеты Plus добавляют аттракционы, например зиплайн Snow Bullet над склоном. Чтобы кататься на лыжах или сноуборде на основном склоне, нужен отдельный ски-пасс и умение поворачивать и тормозить; новички сначала берут урок.",
            "В некоторые предложения входит индивидуальный трансфер из отеля, другие совмещают Ski Dubai с катком Dubai Ice Rink или автобусом hop-on hop-off. В описании каждого предложения указано, какие аттракционы и снаряжение входят в стоимость. Список отсортирован по отзывам путешественников."
          ]
        },
        {
          "h": "Практические советы",
          "p": [
            "У Mall of the Emirates есть своя станция на красной ветке метро, так что добраться легко и без трансфера. Перчатки и шапка входят в комплект не всегда — возьмите свои или купите в магазине на месте. Детям до 13 лет на аттракционах обязателен шлем.",
            "Ski Dubai работает круглый год, с утра до позднего вечера; больше всего людей в выходные и летом во второй половине дня, когда это самое прохладное место в городе. Большинству семей хватает двух-трёх часов в снежном парке."
          ]
        }
      ],
      "faq": [
        {
          "q": "Что входит в билет в Ski Dubai?",
          "a": "Билет Snow Park включает доступ в парк на весь день, зимнюю одежду — куртку, брюки, ботинки и носки — и обычно поездку на кресельном подъёмнике и на Mountain Thriller. В билетах Plus аттракционов больше; точный список — в описании."
        },
        {
          "q": "Нужна ли тёплая одежда для Ski Dubai?",
          "a": "Нет: куртку, брюки, ботинки и носки выдают. Перчатки и шапка входят не всегда — возьмите свои или купите на месте; под комбинезон наденьте длинные брюки и носки."
        },
        {
          "q": "Можно ли кататься на лыжах новичку?",
          "a": "В снежном парке кататься на санках и играть в снегу может любой. Основной склон — для лыжников и сноубордистов, которые умеют поворачивать и тормозить; новичкам сначала нужен урок."
        },
        {
          "q": "Подходит ли Ski Dubai для детей?",
          "a": "Да — снежный парк, аттракционы и пингвины рассчитаны на семьи. Совсем маленьких детей пускают не на все аттракционы, а до 13 лет обязателен шлем; возрастные правила указаны в описании."
        }
      ]
    },
    "dubai-aquarium": {
      "title": "Билеты в Dubai Aquarium",
      "intro": "Акулы и скаты над головой в стеклянном тоннеле, пингвины и выдры в зоопарке этажом выше — в Dubai Mall, у подножия Бурдж-Халифы.",
      "meta": "Билеты в Dubai Aquarium & Underwater Zoo: стеклянный тоннель, подводный зоопарк, Penguin Cove и комбо с Бурдж-Халифа At the Top, в Dubai Mall.",
      "seoTitle": "Dubai Aquarium: билеты в океанариум и подводный зоопарк",
      "heading": "Билеты в Dubai Aquarium",
      "guideTitle": "Как спланировать посещение Dubai Aquarium",
      "guide": [
        {
          "h": "Аквариум, тоннель и зоопарк",
          "p": [
            "Dubai Aquarium & Underwater Zoo находится на первом этаже Dubai Mall в Даунтауне. В его аквариуме на 10 миллионов литров живут тысячи животных — песчаные тигровые акулы, скаты, групперы и стаи рифовых рыб — за одним из самых больших акриловых стёкол в мире. Часть аквариума видна бесплатно прямо из торгового центра; по билету вы попадаете внутрь.",
            "Внутри под аквариумом проходит тоннель длиной около 48 метров: акулы и скаты плавают над вами и вокруг. Этажом выше подводный зоопарк — пингвины, выдры, крокодил, обитатели тропического леса и скалистого берега; в течение дня проходят кормления и рассказы смотрителей."
          ]
        },
        {
          "h": "Какой билет выбрать",
          "p": [
            "Базовый билет включает тоннель и подводный зоопарк. Билеты Penguin Cove добавляют зону пингвинов, билеты Explorer — ещё больше, например прогулку на лодке со стеклянным дном над аквариумом или экскурсию за кулисы. Погружение с акулами и снорклинг в клетке бронируются отдельно, для них есть ограничения по возрасту и умению плавать.",
            "Бурдж-Халифа стоит в том же торговом центре, поэтому многие предложения объединяют океанариум с At the Top, часто с трансфером из отеля. Другие включают только трансфер. Что входит, указано в описании каждого предложения. Список отсортирован по отзывам путешественников."
          ]
        },
        {
          "h": "Практические советы",
          "p": [
            "Станция метро Burj Khalifa/Dubai Mall на Красной линии соединена с торговым центром крытым переходом с кондиционером. Океанариум открыт ежедневно с утра до позднего вечера; спокойнее всего утром в будни, больше всего людей в выходные после обеда.",
            "На тоннель и зоопарк хватит одного-двух часов; прогулка на лодке или встреча с животными добавит ещё час. Если берёте комбо, сначала забронируйте время на Бурдж-Халифу, а океанариум посетите до или после — входы в нескольких минутах ходьбы друг от друга."
          ]
        }
      ],
      "faq": [
        {
          "q": "Что входит в билет в Dubai Aquarium?",
          "a": "Базовый билет включает тоннель и подводный зоопарк. Билеты Penguin Cove и Explorer добавляют зону пингвинов и дополнения вроде прогулки на лодке со стеклянным дном; точный список — в описании."
        },
        {
          "q": "Можно ли посмотреть Dubai Aquarium бесплатно?",
          "a": "Часть главного аквариума видна без билета через большое стекло на первом этаже Dubai Mall. В тоннель под аквариумом и в подводный зоопарк нужен билет."
        },
        {
          "q": "Сколько времени занимает посещение Dubai Aquarium?",
          "a": "Большинство посетителей проводят в тоннеле и зоопарке один-два часа. Прогулка на лодке, встреча с пингвинами или комбо с Бурдж-Халифой добавляют от одного до трёх часов."
        },
        {
          "q": "Подходит ли Dubai Aquarium для детей?",
          "a": "Да — тоннель, пингвины и выдры очень нравятся детям, а весь визит проходит в помещении с кондиционером. Для погружения с акулами и некоторых встреч с животными есть минимальный возраст; проверьте описание."
        }
      ]
    },
    "yas-island": {
      "title": "Билеты на остров Яс",
      "intro": "Остров парков развлечений в Абу-Даби — Ferrari World, Warner Bros. World, Yas Waterworld и SeaWorld — как поездка на день из Дубая.",
      "meta": "Билеты на остров Яс из Дубая: Ferrari World, Warner Bros. World Абу-Даби, Yas Waterworld и билеты в несколько парков, с трансфером или экскурсией.",
      "seoTitle": "Остров Яс: билеты в Ferrari World и Warner Bros",
      "heading": "Билеты в парки острова Яс",
      "guideTitle": "Как спланировать день на острове Яс",
      "guide": [
        {
          "h": "Парки острова",
          "p": [
            "На острове Яс на окраине Абу-Даби собраны крупнейшие парки развлечений страны, в нескольких минутах друг от друга. Ferrari World под огромной красной крышей — дом Formula Rossa, одних из самых быстрых американских горок в мире; есть и аттракционы поспокойнее, и история марки. Warner Bros. World тоже крытый: Looney Tunes и супергерои DC в тематических зонах вроде Готэм-Сити и Метрополиса.",
            "Рядом — Yas Waterworld, открытый аквапарк с горками и волновыми бассейнами, SeaWorld Yas Island, морской парк с аттракционами и шоу под одной крышей, и CLYMB с аэротрубой и скалодромом. На трассе Yas Marina Circuit в конце года проходит Гран-при Абу-Даби «Формулы-1»."
          ]
        },
        {
          "h": "Какой билет выбрать",
          "p": [
            "Билет в один парк действует один день. Билеты в несколько парков позволяют выбрать два или три парка на несколько дней — это выгодно, если вы ночуете в Абу-Даби или приезжаете снова. В некоторых предложениях парк выбирают при бронировании.",
            "Из Дубая многие предложения включают трансфер из отеля, а некоторые совмещают парк с обзорной экскурсией по Абу-Даби — утром мечеть шейха Зайда, днём парк. Что входит — парк, трансфер, остановки, — указано в описании. Список отсортирован по отзывам путешественников."
          ]
        },
        {
          "h": "Практические советы",
          "p": [
            "До острова Яс около полутора часов на машине из Дубая, в час пик дольше, поэтому день в парке — это целый день: выезжайте утром, чтобы успеть к открытию. Ferrari World, Warner Bros. World и SeaWorld крытые и с кондиционерами — хороший выбор летом; в Yas Waterworld лучше ехать с октября по апрель или с самого утра.",
            "На самых мощных аттракционах есть ограничения по росту и здоровью — проверьте их заранее, если едете с детьми. Для комбо с Большой мечетью нужна одежда, закрывающая руки и ноги, а женщинам — платок."
          ]
        }
      ],
      "faq": [
        {
          "q": "Далеко ли остров Яс от Дубая?",
          "a": "Около полутора часов на машине от центра Дубая, от Дубай Марины и Джебель-Али немного меньше. Большинство предложений включает трансфер из отеля в обе стороны."
        },
        {
          "q": "Какой парк на острове Яс лучше для детей?",
          "a": "Младшим детям больше всего подходит Warner Bros. World — мультяшные герои и спокойные аттракционы. В Ferrari World и Yas Waterworld больше экстрима для подростков; SeaWorld подходит для любого возраста."
        },
        {
          "q": "Можно ли посетить два парка за один день?",
          "a": "Можно, но утомительно: каждый парк легко занимает целый день. Билеты в несколько парков действуют несколько дней, поэтому большинство распределяет визиты."
        },
        {
          "q": "Работают ли парки острова Яс летом?",
          "a": "Да — Ferrari World, Warner Bros. World и SeaWorld крытые и с кондиционерами круглый год. Yas Waterworld под открытым небом; летом приезжайте рано, до полуденной жары."
        }
      ]
    },
    "date-night": {
      "title": "Свидание",
      "short": "Свидание",
      "intro": "Прогулки на закате, ужин с видом и вечер в пустыне — идеи для вечера вдвоём.",
      "meta": "Идеи для свидания в Дубае: прогулки на закате, ужин с видом и романтический вечер в пустыне."
    },
    "beach-days": {
      "title": "Пляжный день",
      "short": "Пляжный день",
      "intro": "Пляжные клубы, день на лодке и время на воде у Джумейры, Пальмы и Марины.",
      "meta": "Пляжный отдых в Дубае: пляжные клубы, морские прогулки и отдых на воде у Джумейры, Пальмы и Дубай Марины."
    },
    "art-and-culture": {
      "title": "Искусство и культура",
      "short": "Искусство и культура",
      "intro": "Музеи, галереи, исторические кварталы и истории мечетей и базаров.",
      "meta": "Искусство и культура в Дубае: музеи, галереи, исторические кварталы, мечети и базары."
    },
    "luxury": {
      "title": "Роскошь",
      "short": "Роскошь",
      "intro": "Частные яхты, полёты на вертолёте и самые эксклюзивные способы провести день в городе.",
      "meta": "Роскошный отдых в Дубае: аренда частной яхты, полёты на вертолёте и эксклюзивные экскурсии."
    },
    "adventure": {
      "title": "Приключения на природе",
      "short": "Приключения",
      "intro": "Прыжок с парашютом над Пальмой, воздушный шар на рассвете, зиплайны и походы в горах Хатты.",
      "meta": "Приключения в Дубае: прыжки с парашютом, полёты на воздушном шаре, зиплайны, багги и походы в Хатте."
    },
    "downtown-dubai": {
      "title": "Даунтаун Дубай",
      "short": "Даунтаун",
      "intro": "Бурдж-Халифа, Dubai Mall и шоу фонтанов — самые оживлённые квадратные километры города.",
      "meta": "Чем заняться в Даунтауне Дубая: Бурдж-Халифа, Dubai Mall, Поющий фонтан и Dubai Opera."
    },
    "dubai-marina": {
      "title": "Дубай Марина",
      "short": "Дубай Марина",
      "intro": "Канал среди небоскрёбов: круизы на доу с ужином среди огней, гидроциклы до Пальмы и набережная у пляжа JBR.",
      "meta": "Чем заняться в Дубай Марине: круизы на доу с ужином по каналу, туры на гидроцикле к Пальме и Бурдж-эль-Араб, пляж JBR и экскурсии с остановкой здесь.",
      "seoTitle": "Чем заняться в Дубай Марине: круизы и гидроциклы",
      "heading": "Чем заняться в Дубай Марине",
      "guideTitle": "Дубай Марина: что нужно знать",
      "guide": [
        {
          "h": "Марина и JBR",
          "p": [
            "Дубай Марина — канал длиной около трёх километров, прорытый в берегу и окружённый жилыми небоскрёбами, с набережной Marina Walk по обеим сторонам. Со стороны моря к нему примыкает JBR — Jumeirah Beach Residence — с городским пляжем и The Walk, улицей кафе и магазинов у подножия башен. Чуть дальше от берега лежит остров Bluewaters.",
            "После заката это самый оживлённый район нового Дубая, и почти всё, что здесь можно забронировать, происходит на воде."
          ]
        },
        {
          "h": "Круизы с ужином по каналу",
          "p": [
            "Круизы на доу в Марине — вечерние: около двух часов по каналу на деревянной доу или современном судне со стеклянной крышей, с ужином-буфетом, музыкой или шоу на борту и подсвеченными башнями вокруг. Некоторые выходят из канала в море, чтобы показать небоскрёбы с воды.",
            "По сравнению с круизами по Крику в старом Дубае Марина — современная декорация: небоскрёбы вместо рынков. Во многие предложения входит трансфер из отеля; что именно включено, от напитков до меню, указано в описании."
          ]
        },
        {
          "h": "Гидроциклы и не только",
          "p": [
            "Туры на гидроцикле стартуют в Марине и идут вдоль берега к Пальме, Atlantis и Бурдж-эль-Араб — от 30 минут до двух часов, с гидом на втором гидроцикле и обычно без прав. Комбинированные туры добавляют круиз по Марине к обзорной экскурсии или сафари в пустыне, а в JBR есть крытый мини-гольф с ультрафиолетовой подсветкой — вариант на вечер с детьми.",
            "Частные яхты тоже в основном отходят из Марины — для них есть отдельная страница «Яхты и лодки». Список здесь отсортирован по отзывам путешественников."
          ]
        }
      ],
      "faq": [
        {
          "q": "Чем заняться в Дубай Марине?",
          "a": "Поужинать на круизе по каналу, прокатиться на гидроцикле к Пальме и Бурдж-эль-Араб, провести вечер на Marina Walk или The Walk в JBR, а днём — пляж JBR."
        },
        {
          "q": "Сколько длится круиз на доу по Дубай Марине?",
          "a": "Обычно около двух часов вечером, с ужином на борту. Если в стоимость входит трансфер из отеля, добавьте время на дорогу туда и обратно."
        },
        {
          "q": "Круиз на доу: Марина или Крик?",
          "a": "Марина — это современные небоскрёбы и более оживлённая атмосфера; Крик в старом Дубае — традиционный вариант, мимо рынков и старых торговых доу, и обычно спокойнее. Ужин на борту есть и там, и там."
        },
        {
          "q": "Как добраться до Дубай Марины?",
          "a": "На метро, на трамвае Dubai Tram, который ходит через Марину и вдоль JBR, или на такси. Во многие круизы и туры входит трансфер из отеля."
        }
      ]
    },
    "palm-jumeirah": {
      "title": "Пальма Джумейра",
      "short": "Пальма Джумейра",
      "intro": "Остров в форме пальмы у побережья Джумейры: Aquaventure в Atlantis, вид с The Palm Tower, гидроциклы и вертолёты над листьями пальмы.",
      "meta": "Чем заняться на Пальме Джумейра: билеты в Aquaventure в Atlantis, смотровая площадка The View at The Palm, гидроциклы и полёты на вертолёте над островом.",
      "seoTitle": "Пальма Джумейра: Atlantis, The View и развлечения",
      "heading": "Чем заняться на Пальме Джумейра",
      "guideTitle": "Пальма Джумейра: что нужно знать",
      "guide": [
        {
          "h": "Остров",
          "p": [
            "Пальма Джумейра — насыпной остров в форме пальмы: ствол, уходящий в море, шестнадцать «листьев», застроенных виллами, и полумесяц вокруг них, который защищает от волн. На вершине полумесяца стоит Atlantis The Palm, рядом — Atlantis The Royal.",
            "Форму острова видно только сверху или с воды — и большинство туров здесь как раз об этом."
          ]
        },
        {
          "h": "Atlantis и Aquaventure",
          "p": [
            "Aquaventure, аквапарк отеля Atlantis, — главная достопримечательность острова: горки, проходящие через лагуны с акулами, длинная «ленивая река» и собственный пляж — закладывайте целый день. Океанариум в отеле и встречи с акулами можно забронировать отдельно.",
            "Билеты бывают с трансфером из отеля и без. Без трансфера — на такси или на монорельсе Palm Monorail, который идёт вдоль ствола с материка до Atlantis."
          ]
        },
        {
          "h": "Сверху и с воды",
          "p": [
            "The View at The Palm — смотровая площадка на 52-м этаже The Palm Tower, на середине ствола, на высоте около 240 метров: вся пальма лежит под вами. Вертолётные полёты из района Atlantis проходят над листьями пальмы, Бурдж-эль-Араб и Мариной, самые короткие — около двенадцати минут.",
            "Туры на гидроцикле огибают полумесяц мимо Atlantis и Бурдж-эль-Араб, чаще всего из соседней Марины. Морские прогулки вокруг острова — на странице «Яхты и лодки». Список здесь отсортирован по отзывам путешественников."
          ]
        }
      ],
      "faq": [
        {
          "q": "Чем заняться на Пальме Джумейра?",
          "a": "Провести день в аквапарке Aquaventure в Atlantis, увидеть остров со смотровой площадки The View at The Palm или с вертолёта, объехать полумесяц на гидроцикле или сходить в океанариум Atlantis."
        },
        {
          "q": "Откуда лучший вид на Пальму Джумейра?",
          "a": "Сверху. С The View at The Palm на 52-м этаже The Palm Tower видна вся форма острова; полёт на вертолёте даёт открыточный вид с ещё большей высоты."
        },
        {
          "q": "Сколько времени нужно на Aquaventure?",
          "a": "Целый день: горки, «ленивая река» и пляж легко занимают шесть часов и больше. В тёплые месяцы приезжайте к открытию — к полудню у больших горок собираются очереди."
        },
        {
          "q": "Как добраться до Пальмы Джумейра?",
          "a": "На такси или на монорельсе Palm Monorail, который идёт вдоль ствола с материка до Atlantis. Во многие билеты входит трансфер из отеля."
        }
      ]
    },
    "old-dubai": {
      "title": "Старый Дубай и Крик",
      "short": "Старый Дубай",
      "intro": "Ветряные башни Аль-Фахиди, переправа на абре и золотой и пряный рынки Дейры.",
      "meta": "Чем заняться в старом Дубае: пешие и обзорные экскурсии по Аль-Фахиди и рынкам, переправа на абре через Крик и круизы на доу с ужином по Крику.",
      "seoTitle": "Старый Дубай: экскурсии по Крику, рынкам и Аль-Фахиди",
      "heading": "Чем заняться в старом Дубае",
      "guideTitle": "Старый Дубай: что нужно знать",
      "guide": [
        {
          "h": "Два берега Крика",
          "p": [
            "Дубай-Крик — морской залив, вокруг которого вырос город. На западном берегу, в Бур-Дубае, лежит квартал Аль-Фахиди — переулки с отреставрированными домами из кораллового камня и ветряными башнями, небольшие музеи и галереи — и текстильный рынок; на другом берегу, в Дейре, — золотой и пряный рынки. Вдоль берега Бур-Дубая тянется Al Seef — набережная, заново построенная в старом стиле.",
            "Именно здесь проходят пешие экскурсии и большая часть классических обзорных туров — до или после Бурдж-Халифа и пляжей."
          ]
        },
        {
          "h": "Абры, рынки и экскурсии с гидом",
          "p": [
            "Абра — маленькое деревянное водное такси — пересекает Крик за несколько минут и входит почти в каждый тур здесь. Пешие экскурсии с гидом проходят по Аль-Фахиди, через Крик на абре и по рынкам за два–четыре часа, некоторые — с дегустацией эмиратской кухни; обзорные туры на полдня и на день добавляют фотостопы в новом Дубае.",
            "Идите утром или ближе к вечеру: днём в переулках почти нет тени, а рынки оживают к вечеру. Торговаться на рынках принято; в ювелирных лавках цену в основном определяет вес изделия."
          ]
        },
        {
          "h": "Круизы с ужином по Крику",
          "p": [
            "Круизы на доу по Крику — традиционный вариант: около двух часов вечером на деревянной доу мимо подсвеченных рынков и старых торговых судов, с ужином-буфетом и шоу на борту — часто с танцором танура. Обычно они спокойнее, чем круизы в Марине.",
            "Некоторые комбо-туры совмещают экскурсию по старому Дубаю с сафари в пустыне или круизом по Крику на два дня и больше. Список отсортирован по отзывам путешественников."
          ]
        }
      ],
      "faq": [
        {
          "q": "Чем заняться в старом Дубае?",
          "a": "Пройтись по кварталу Аль-Фахиди, переправиться через Крик на абре, заглянуть на золотой и пряный рынки в Дейре и закончить день круизом с ужином по Крику — самостоятельно на это уйдёт целый день, с гидом — полдня."
        },
        {
          "q": "Где находится старый Дубай?",
          "a": "Вокруг Дубай-Крика, на севере города: Бур-Дубай на западном берегу, Дейра — на восточном. От Даунтауна 20–30 минут на такси, туда ходят обе линии метро."
        },
        {
          "q": "Как одеться для прогулки по старому Дубаю?",
          "a": "В лёгкую одежду, закрывающую плечи и колени: это обязательно для входа в мечеть и уместно в старом квартале и на рынках. И в удобную обувь — туры в основном пешие."
        },
        {
          "q": "Стоит ли плыть на круиз на доу по Дубай-Крику?",
          "a": "Да, если хочется увидеть традиционный Дубай: деревянные доу, подсвеченные рынки на берегах и более спокойный вечер, чем в Марине. Ужин обычно — буфет с арабскими и международными блюдами."
        }
      ]
    },
    "seeAlso": "Смотрите также:",
    "faqTitle": "Частые вопросы",
    "boats": {
      "seoTitle": "Аренда яхты в Дубае: частные прогулки на яхте",
      "heading": "Частные прогулки на яхтах и лодках в Дубае",
      "meta": "Аренда частной яхты в Дубае по часам: прогулки с экипажем из Дубай Марины мимо JBR, Ain Dubai, Пальмы Джумейра, Atlantis и Бурдж-эль-Араб.",
      "guideTitle": "Как выбрать прогулку на яхте в Дубае",
      "guide": [
        {
          "h": "Как устроена частная прогулка на яхте",
          "p": [
            "Частная прогулка на яхте в Дубае — это аренда с почасовой оплатой: лодка, капитан и экипаж забронированы только для вашей компании, посторонних на борту нет. Большинство прогулок длится от двух до четырёх часов; аренда на полдня или на весь день подходит тем, кто хочет купаться, загорать и никуда не спешить.",
            "В описании указано, что это за судно — моторная лодка, моторная яхта или катамаран, — сколько длится прогулка и что входит в стоимость на борту. Бронирование проходит на сайте нашего партнёра, где владелец лодки подтверждает время и детали для вашей компании."
          ]
        },
        {
          "h": "Классический маршрут из Дубай Марины",
          "p": [
            "Почти все прогулки начинаются в Дубай Марине — одной из крупнейших искусственных гаваней мира, окружённой жилыми небоскрёбами. Оттуда лодка выходит мимо пляжей и набережной JBR и острова Bluewaters с колесом обозрения Ain Dubai, а затем идёт вдоль внешнего полумесяца Пальмы Джумейра к отелю Atlantis The Palm.",
            "Более длинные маршруты продолжаются на юг к Бурдж-эль-Араб — отелю в форме паруса на собственном острове у пляжа Джумейра, самому известному виду любой прогулки. За два часа маршрут обычно заканчивается у Пальмы; от трёх часов остаётся время встать на якорь и искупаться."
          ]
        },
        {
          "h": "Закат, вечеринка или праздник?",
          "p": [
            "Самые популярные — прогулки на закате и вечером: небоскрёбы окрашиваются золотом, а на обратном пути в Марину загораются огни города. Дневные прогулки — для купания, остановки у Пальмы и ясных видов на побережье.",
            "Многие владельцы предлагают тематические прогулки: дни рождения и годовщины, предложения руки и сердца, вечеринки на яхте с музыкой или барбекю на борту. Гидроцикл, кейтеринг или украшения обычно заказываются отдельно — проверьте, что входит в предложение.",
            "Прохладные месяцы, примерно с октября по апрель, — высокий сезон на воде. Летом прогулки рано утром и вечером позволяют избежать самой сильной жары."
          ]
        }
      ],
      "faq": [
        {
          "q": "Сколько стоит аренда яхты в Дубае?",
          "a": "В каждом предложении указана цена «от» за всю прогулку; она зависит от размера лодки, длительности и сезона. Дешевле всего небольшие моторные лодки на два часа, дороже всего большие моторные яхты на целый день. Окончательную цену для вашей компании подтверждает владелец при бронировании."
        },
        {
          "q": "Сколько должна длиться прогулка на яхте в Дубае?",
          "a": "Двух часов хватит на Марину, JBR, Ain Dubai и Пальму. Выбирайте три-четыре часа, чтобы дойти до Бурдж-эль-Араб и остановиться искупаться, и полдня или целый день — для спокойного дня в море."
        },
        {
          "q": "Яхта только для нашей компании?",
          "a": "Да. Это частная аренда: лодка и экипаж забронированы для вашей компании, других пассажиров нет. Сколько гостей вмещает лодка, указано в её описании."
        },
        {
          "q": "Можно ли купаться во время прогулки?",
          "a": "На многих длинных прогулках лодка встаёт на якорь у Пальмы или у пляжей, чтобы гости могли искупаться; в описании сказано, входит ли купание в программу. Возьмите купальник и солнцезащитный крем."
        },
        {
          "q": "Когда лучше всего выходить на яхте в Дубае?",
          "a": "Ближе к вечеру и на закате, когда свет мягче всего, а на обратном пути загораются огни небоскрёбов. С октября по апрель погода приятная весь день; летом прохладнее утром и вечером."
        },
        {
          "q": "Откуда отправляются прогулки на яхтах в Дубае?",
          "a": "Чаще всего из Дубай Марины, иногда из других гаваней на побережье. Точное место встречи владелец подтверждает после бронирования."
        }
      ]
    },
    "tours": {
      "seoTitle": "Экскурсии в Дубае: сафари, круизы, билеты",
      "heading": "Экскурсии в Дубае",
      "meta": "Все экскурсии в Дубае по отзывам: сафари в пустыне, обзорные туры, круизы на доу и яхтах, билеты на Бурдж-Халифу, воздушный шар и поездки в Абу-Даби.",
      "guideTitle": "Как выбрать экскурсию в Дубае",
      "guide": [
        {
          "h": "Какие бывают экскурсии",
          "p": [
            "Экскурсии в Дубае делятся на несколько групп. Сафари в пустыне — это поездка в дюны за городом: джип-сафари по барханам, катание на верблюде и ужин в лагере бедуинов. Обзорные экскурсии за несколько часов показывают оба Дубая: старый город у залива Дубай-Крик с рынками-суками и лодками-абрами и новый — Даунтаун, Пальму и Марину. Билеты на достопримечательности — это Бурдж-Халифа, Dubai Frame, океанариум, Ski Dubai и аквапарки, часто с фиксированным временем входа.",
            "На воде — круизы на доу с ужином по Крику и в Марине, частные прогулки на яхте и водные развлечения: гидроциклы, парасейлинг, флайборд. Полёты на воздушном шаре и вертолёте показывают пустыню и небоскрёбы сверху, а поездки на день уводят за пределы Дубая — чаще всего в Абу-Даби, к мечети шейха Зайда, Лувру и тематическим паркам острова Яс."
          ]
        },
        {
          "h": "Как спланировать дни в Дубае",
          "p": [
            "Планируйте по времени суток. Утро — самое прохладное время для пеших прогулок и старого города и единственное для полёта на воздушном шаре: он стартует на рассвете. Середину дня лучше провести под крышей — на смотровой площадке, в музее, океанариуме или торговом центре. Конец дня — время сафари в пустыне, вечер — круизов на доу, яхт на закате и огней ночного города.",
            "На главное хватит трёх-четырёх дней: день на Даунтаун и Бурдж-Халифу, день на старый Дубай и рынки, день на пустыню и вечер на воде. Пятый день оставляет время для Абу-Даби или пляжа. С октября по апрель погода подходит для всего; летом выбирайте утренние и вечерние экскурсии и достопримечательности с кондиционером."
          ]
        },
        {
          "h": "Групповая, индивидуальная или без очереди?",
          "p": [
            "Групповые экскурсии — самый доступный способ увидеть город и пустыню: вы едете с другими туристами в одной машине или на одной лодке с гидом. Индивидуальные стоят дороже, зато идут по вашему расписанию — машина, гид или яхта только для вас. Это стоит того для семей с детьми, пар с особым поводом и всех, у кого плотная программа.",
            "У билетов сравнивайте, что входит в цену: время входа или свободное посещение, какие этажи и зоны доступны, есть ли трансфер из отеля. Многие экскурсии забирают туристов из отелей в центре Дубая; если вы живёте дальше, проверьте зону трансфера в описании."
          ]
        },
        {
          "h": "Как устроен этот список",
          "p": [
            "Здесь собраны все экскурсии и впечатления в Дубае из нашего каталога, по отзывам: экскурсия с множеством хороших отзывов стоит выше той, которой поставили высший балл всего несколько гостей. Через поиск можно найти место или занятие по названию, а в категории — короткий список со своим путеводителем.",
            "Бронирование — на сайте нашего партнёра: Viator для экскурсий и билетов, Click&Boat для яхт. Там до оплаты видны актуальная цена, свободные даты и условия отмены. Многие экскурсии можно бесплатно отменить за 24 часа до начала."
          ]
        }
      ],
      "faq": [
        {
          "q": "Какие экскурсии в Дубае самые лучшие?",
          "a": "Выше всего туристы оценивают вечернее сафари в пустыне с ужином-барбекю, билет на Бурдж-Халифу на закате, круиз на доу с ужином, прогулку по старому Дубаю с переправой на абре через Крик и частную яхту мимо Пальмы и Бурдж-эль-Араба. В этом списке первыми идут экскурсии с лучшими отзывами."
        },
        {
          "q": "Сколько дней нужно на экскурсии в Дубае?",
          "a": "Трёх-четырёх дней хватит на главное: Даунтаун и Бурдж-Халифу, старый Дубай с рынками, сафари в пустыне и прогулку по воде. Добавьте день на Абу-Даби, тематический парк или полёт на воздушном шаре."
        },
        {
          "q": "Входит ли в экскурсию трансфер из отеля?",
          "a": "Большинство сафари, обзорных экскурсий и поездок на день включают трансфер из отелей в центре Дубая — Даунтауна, Марины, JBR, Дейры — и обратно. В билеты и круизы он обычно не входит; что включено и какие районы обслуживаются, указано в описании."
        },
        {
          "q": "Что выбрать: групповую или индивидуальную экскурсию?",
          "a": "Групповые дешевле и подходят, если вы не против попутчиков. Индивидуальная стоит доплаты, если вы с детьми, хотите свой темп или отмечаете событие: машина, гид или лодка — только для вашей компании."
        },
        {
          "q": "Можно ли забронировать экскурсию на сегодня или на завтра?",
          "a": "Часто да: многие сафари, круизы и билеты можно купить накануне или даже в день поездки, если остались места. В высокий сезон, с ноября по март, а также в выходные и праздники лучше бронировать за несколько дней."
        },
        {
          "q": "Есть ли экскурсии на русском языке?",
          "a": "Большинство экскурсий проходит на английском. Часть обзорных экскурсий и сафари предлагается и на других языках, в том числе на русском; язык указан в описании экскурсии на сайте партнёра."
        }
      ]
    },
    "guides": {
      "guideTitle": "Как спланировать поездку в Дубай",
      "guide": [
        {
          "h": "Когда лучше ехать в Дубай",
          "p": [
            "Лучшее время для поездки в Дубай — с ноября по март: днём около +25 °C, вечерами достаточно прохладно, чтобы ужинать на улице, и в этот сезон открыты Global Village и Miracle Garden. Сафари в пустыне, круизы на доу и пляжные дни тогда комфортнее всего.",
            "Апрель и октябрь — тёплое межсезонье. С мая по сентябрь температура выше +40 °C, день уходит под крышу — торговые центры, аквапарки, Ski Dubai, аквариум, — зато отели дешевле всего. Рамадан каждый год сдвигается примерно на одиннадцать дней раньше: достопримечательности работают, но часы меняются, поэтому проверьте даты до бронирования."
          ]
        },
        {
          "h": "Сколько дней нужно на Дубай",
          "p": [
            "За три дня можно увидеть главное: Даунтаун с Бурдж-Халифой и шоу фонтанов, старый Дубай у Крика с переправой на абре и рынками, сафари в пустыне. За пять дней добавляются Пальма Джумейра и Дубай Марина, пляжный день и поездка в Абу-Даби.",
            "Неделя оставляет время для тематических парков — Dubai Parks and Resorts или острова Яс в Абу-Даби, — полёта на воздушном шаре над дюнами или прогулки на яхте и для неспешных дней. В статьях путеводителя есть маршруты по дням, которые можно взять за основу."
          ]
        },
        {
          "h": "Транспорт и советы туристам",
          "p": [
            "Метро связывает аэропорт, Дейру, Даунтаун, Аль-Баршу и Дубай Марину; платят картой Nol, она же работает в автобусах и трамвае Марины. Для остального удобны такси и приложения для заказа машин. Выходные — суббота и воскресенье, в пятницу после обеда многолюдно.",
            "На пляже и у бассейна одежда свободная; в торговых центрах, старом городе и мечетях прикрывайте плечи и колени. Алкоголь подают только в лицензированных отелях, барах и ресторанах. Дирхам привязан к доллару США, карты принимают почти везде."
          ]
        },
        {
          "h": "Как устроен наш путеводитель по Дубаю",
          "p": [
            "Каждая статья отвечает на один вопрос планирования — когда ехать, куда пойти с детьми, какое сафари выбрать — и ссылается на экскурсии, билеты и события Dubai To-Do, чтобы можно было сравнить актуальные цены и забронировать прямо со страницы. Мы обновляем статьи, когда меняются каталог и афиша города."
          ]
        }
      ],
      "faq": [
        {
          "q": "Какой месяц лучший для поездки в Дубай?",
          "a": "С ноября по март: тепло, но не жарко, и работают сезонные достопримечательности. Декабрь и январь — самые людные и дорогие; ноябрь, февраль и март — хороший компромисс."
        },
        {
          "q": "Сколько дней нужно на Дубай?",
          "a": "Четырёх-пяти дней хватит на Даунтаун, старый Дубай, сафари в пустыне, Пальму и Марину и поездку в Абу-Даби. Три дня — на главное; неделя — с тематическими парками и пляжем."
        },
        {
          "q": "Безопасно ли в Дубае туристам?",
          "a": "Да. Уровень преступности в Дубае очень низкий, город удобен для поездки в одиночку и с детьми. Соблюдайте местные законы: за пьянство в общественных местах, наркотики и непристойное поведение строго наказывают."
        },
        {
          "q": "Нужна ли виза в Дубай?",
          "a": "Зависит от паспорта: гражданам многих стран бесплатную визу ставят по прилёте, другим нужно оформить её заранее. Перед поездкой проверьте правила для своего гражданства в официальных источниках ОАЭ."
        },
        {
          "q": "Что надеть туристу в Дубае?",
          "a": "Лёгкую одежду из дышащих тканей. Купальник уместен на пляже и у бассейна; в торговых центрах, старом городе и мечетях прикрывайте плечи и колени — и возьмите кофту от сильных кондиционеров."
        }
      ]
    },
    "new-years-eve": {
      "title": "Новый год в Дубае",
      "intro": "Гала-ужины, вечеринки в бич-клубах, концерты и круизы в последнюю ночь года — и где смотреть салют у Бурдж-Халифы, на Пальме и в Марине.",
      "meta": "Новый год в Дубае: вечеринки, гала-ужины, концерты и круизы с видом на салют, где смотреть фейерверк у Бурдж-Халифы, перекрытия дорог и метро.",
      "seoTitle": "Новый год в Дубае: вечеринки, круизы и салют",
      "heading": "Новый год в Дубае: вечеринки, ужины и салют",
      "eventsTitle": "Вечеринки, гала-ужины и концерты",
      "eventsOff": "Вечеринки и гала-ужины к следующему Новому году поступают в продажу осенью — они появятся здесь сразу же. А путеводитель ниже действует круглый год.",
      "eventsOffLink": "Что идёт в Дубае сейчас",
      "toursTitle": "Новогодние круизы",
      "toursMore": "Все прогулки на яхтах и лодках",
      "guideTitle": "Как встретить Новый год в Дубае",
      "guide": [
        {
          "h": "Вечеринки, гала-ужины и концерты",
          "p": [
            "Новый год в Дубае почти весь по билетам: гала-ужины в отелях с сет-меню и живой музыкой, бич-клубы с известными диджеями, концерты арабских и мировых звёзд, вечеринки с обратным отсчётом на крышах. Многие устроены так, чтобы в полночь гости увидели один из официальных фейерверков, — перед выбором проверьте, действительно ли площадка смотрит на Бурдж-Халифу, Пальму или море.",
            "В билет обычно входит ужин или напитки; чем лучше вид, тем дороже. Алкоголь подают только заведения с лицензией, на большинство вечеринок пускают с 21 года."
          ]
        },
        {
          "h": "Новый год на воде",
          "p": [
            "Круиз — самый спокойный способ увидеть салют: ни толпы, ни перекрытых дорог, и место к полуночи гарантировано. Доу на Дубай-Крик и в Бизнес-Бей идут к фейерверку у Бурдж-Халифы, яхты из Дубай Марины — мимо JBR к Атлантису и Бурдж-эль-Арабу.",
            "Новогодний круиз длиннее обычной вечерней прогулки, посадка — задолго до полуночи: на воде вы проведёте весь вечер до конца салюта. Частные яхты для компаний разбирают первыми."
          ]
        },
        {
          "h": "Где смотреть салют",
          "p": [
            "Шоу у Бурдж-Халифы в Даунтауне — то, что смотрит весь мир: фейерверк и световое шоу на башне. Район заполняется с середины дня, часть смотровых зон — платные. Салюты бывают и в других местах: у Атлантиса и на Пальме Джумейра, у Бурдж-эль-Араба, на JBR и Bluewaters, у Dubai Frame и в Global Village. Официальный список на ближайшую ночь объявляют в декабре.",
            "Чтобы обойтись без толпы Даунтауна, смотрите с воды или с другого берега: с Дубайского канала, из Бизнес-Бей, с пляжа на JBR или с борта круиза."
          ]
        },
        {
          "h": "Новый год с детьми",
          "p": [
            "Полночь в Даунтауне — это долгое ожидание в плотной толпе, с маленькими детьми тяжело. В Global Village в последние годы устраивали несколько обратных отсчётов за вечер — по полуночи разных стран, — так что салют можно увидеть задолго до сна; другой простой вариант — ужин-круиз или ужин в отеле с видом на фейерверк.",
            "Семейные гала-ужины есть, но многие вечеринки — только для взрослых: возрастное ограничение указано на странице билета."
          ]
        },
        {
          "h": "Перекрытия дорог и метро",
          "p": [
            "Дороги вокруг Бурдж-Халифы перекрывают с середины дня 31 декабря, парковки в Даунтауне заполняются рано. Метро Дубая обычно работает всю ночь, но станции у Бурдж-Халифы вечером могут закрыть, когда район переполнен, — выйдите на станцию раньше и пройдите пешком или приезжайте заранее.",
            "Сразу после полуночи такси и машин в приложениях почти нет: лучше переждать час на месте или ехать на метро."
          ]
        },
        {
          "h": "Когда бронировать",
          "p": [
            "Лучшие гала-ужины, круизы и вечеринки распродают в первой половине декабря, а цены по мере приближения праздника только растут. Бронируйте по возможности в ноябре и читайте условия отмены: многие новогодние билеты невозвратные."
          ]
        }
      ],
      "faq": [
        {
          "q": "Где лучше всего смотреть новогодний салют в Дубае?",
          "a": "Самый большой фейерверк — у Бурдж-Халифы в Даунтауне: его лучше всего видно у Dubai Mall, в Burj Park или из ресторана с видом на башню. Без толпы — с воды во время круиза, из Бизнес-Бей или на салютах у Пальмы, на JBR и в Global Village."
        },
        {
          "q": "Салют у Бурдж-Халифы можно посмотреть бесплатно?",
          "a": "С улиц и набережных Даунтауна — да, но их заполняют за несколько часов до полуночи и закрывают, когда мест нет. Часть смотровых зон у башни в последние годы была платной, как и рестораны, отели и круизы с видом."
        },
        {
          "q": "Во сколько приезжать в Даунтаун в новогоднюю ночь?",
          "a": "Днём или ранним вечером: дороги перекрывают с середины дня, а вход в район закрывают, как только он заполнен, — часто задолго до полуночи."
        },
        {
          "q": "Работает ли метро Дубая в новогоднюю ночь?",
          "a": "Обычно да, всю ночь. Станции рядом с Бурдж-Халифой вечером могут закрыть из-за толпы — заложите в план соседнюю станцию."
        },
        {
          "q": "Можно ли смотреть салют с яхты или доу?",
          "a": "Да — доу и яхты встают на воде к полуночи, это самый спокойный способ увидеть фейерверк. Бронируйте заранее: новогодние круизы раскупают."
        },
        {
          "q": "Когда бронировать Новый год в Дубае?",
          "a": "До конца ноября — тогда выбор лучше всего; популярные гала-ужины, вечеринки и круизы распродают в декабре, а цены к празднику растут."
        }
      ]
    },
    "hotels": {
      "title": "Где остановиться",
      "seoTitle": "Где остановиться в Дубае: лучшие районы и карта отелей",
      "heading": "Где остановиться в Дубае",
      "meta": "Где остановиться в Дубае: Даунтаун, Бизнес-Бэй, Дубай Марина, JBR, Пальма Джумейра, Джумейра или Старый Дубай — кому подходит каждый район, как добираться, и карта отелей с ценами на ваши даты.",
      "intro": "Дубай вытянут вдоль моря: около 40 км побережья от залива Крик и старого города до Марины, а между ними — Бурдж-Халифа. От того, где вы живёте, зависит, начнётся ли день на пляже, в торговом центре или в метро. Здесь — какой каждый район, с картой его отелей и ценами на ваши даты от основных сайтов бронирования.",
      "guideTitle": "Как выбрать и забронировать отель в Дубае",
      "guide": [
        {
          "h": "Пляж или город?",
          "p": [
            "Выберите один район на всю поездку, а не переезжайте между отелями. Пляжные районы — Дубай Марина, JBR, Пальма Джумейра и Джумейра — подходят для отдыха у моря; Даунтаун и Бизнес-Бэй — для первого визита с достопримечательностями, торговыми центрами и фонтаном; Старый Дубай — для бюджета поскромнее и тех, кому интересны рынки-суки и Крик.",
            "Между Даунтауном и Мариной около 25 км: 30–40 минут на такси вне часа пик, чуть дольше на красной ветке метро, которая связывает оба района и с аэропортом."
          ]
        },
        {
          "h": "Когда бронировать",
          "p": [
            "С ноября по март — высокий сезон: тёплые дни и мягкие вечера, а дороже всего — на Рождество и Новый год, когда лучшие номера разбирают заранее. С июня по сентябрь очень жарко и дешевле всего; тогда особенно выгодны курортные отели с бассейнами и пляжными клубами.",
            "Город заполняют и крупные события: выставки, Dubai Shopping Festival, уикенд «Формулы-1» в Абу-Даби. Если ваши даты совпали — бронируйте пораньше."
          ]
        },
        {
          "h": "Что входит в цену",
          "p": [
            "Отели Дубая взимают туристический сбор Tourism Dirham за номер и ночь, его платят в отеле; сайты бронирования обычно показывают его отдельно от цены номера. Проверьте, включён ли завтрак и бесплатны ли для гостей пляж и бассейны курорта.",
            "В Марине, JBR и Даунтауне много апартаментов — это выгодно семьям и на долгий срок: кухня, стиральная машина, часто бассейн в доме."
          ]
        }
      ],
      "faq": [
        {
          "q": "В каком районе Дубая лучше остановиться в первый раз?",
          "a": "В Даунтауне: Бурдж-Халифа, Dubai Mall и фонтан рядом, метро довезёт до старого города и Марины, а большинство экскурсий забирает туристов именно отсюда. Если пляж важнее достопримечательностей, выбирайте Дубай Марину или JBR."
        },
        {
          "q": "Где остановиться в Дубае на пляже?",
          "a": "В JBR, где отели выходят прямо на широкий городской пляж и бульвар The Walk, или на Пальме Джумейра, где у большинства курортов свой пляж. Джумейра у отеля Бурдж-аль-Араб спокойнее: курорты на длинных частных пляжах."
        },
        {
          "q": "Какой район подходит для отдыха с детьми?",
          "a": "Пальма Джумейра и JBR: пляжные курорты с детскими клубами и бассейнами, аквапарк Aquaventure на Пальме, ровная набережная в JBR. Для долгой поездки хороший вариант — апартаменты в Дубай Марине."
        },
        {
          "q": "Где остановиться в Дубае недорого?",
          "a": "В Старом Дубае — Дейре и Бур-Дубае — самые доступные отели, рядом аэропорт, рынки и метро. Бизнес-Бэй — средний вариант недалеко от Даунтауна."
        },
        {
          "q": "Как перемещаться между районами?",
          "a": "Красная ветка метро идёт от аэропорта через Дейру, Бур-Дубай, Даунтаун и Бизнес-Бэй до Марины; трамвай связывает Марину, JBR и монорельс Пальмы. Такси и приложения для заказа машины работают везде."
        },
        {
          "q": "Вы продаёте номера?",
          "a": "Нет. Карта и кнопки «Смотреть отели» показывают предложения основных сайтов бронирования через нашего партнёра Stay22; вы выбираете, бронируете и оплачиваете на сайте бронирования, на его условиях. Мы можем получить комиссию с вашего бронирования — для вас цена не меняется."
        }
      ]
    }
  },
  "tours": {
    "intro": "Все экскурсии и впечатления в Дубае из нашего каталога — сначала с лучшими отзывами.",
    "searchLabel": "Поиск экскурсий",
    "resultsFor": "Результаты по запросу «{{query}}»",
    "noResults": "По запросу «{{query}}» ничего не найдено.",
    "clearSearch": "Сбросить поиск",
    "showMore_one": "Показать ещё {{count}}",
    "showMore_few": "Показать ещё {{count}}",
    "showMore_many": "Показать ещё {{count}}",
    "showMore_other": "Показать ещё {{count}}"
  },
  "boats": {
    "intro": "Частные прогулки на яхтах и лодках в Дубае: лодка с экипажем только для вашей компании — из Дубай Марины мимо Пальмы Джумейра, Atlantis и Бурдж-эль-Араб.",
    "typeLabel": {
      "Motorboat": "Моторная лодка",
      "Sailboat": "Парусная лодка",
      "Catamaran": "Катамаран",
      "RIB": "Лодка RIB",
      "Motor yacht": "Моторная яхта",
      "Houseboat": "Плавучий дом",
      "Boat without licence": "Лодка без прав",
      "Jet ski": "Гидроцикл",
      "Sailing yacht": "Парусная яхта"
    },
    "fallbackTitle": "{{type}} {{name}} — аренда в Дубае",
    "fallbackDescription": "{{type}} {{name}}, аренда на день в Дубае.",
    "perDay": "/ день"
  },
  "empty": {
    "title": "Скоро",
    "text": "Мы подключаем первых партнёров для этого списка. А пока — несколько идей для начала."
  },
  "card": {
    "tour": "Экскурсии и впечатления",
    "boat": "Яхты и круизы",
    "from": "от {{price}}",
    "reviews_one": "{{count}} отзыв",
    "reviews_few": "{{count}} отзыва",
    "reviews_many": "{{count}} отзывов",
    "reviews_other": "{{count}} отзыва"
  },
  "tourFacts": {
    "includedTitle": "Что входит в стоимость",
    "included": "Включено",
    "excluded": "Не включено",
    "meetingTitle": "Встреча и трансфер",
    "knowBeforeTitle": "Важно знать",
    "private": "Индивидуальная экскурсия — только ваша группа",
    "shared_one": "Групповая экскурсия, до {{count}} участника",
    "shared_few": "Групповая экскурсия, до {{count}} участников",
    "shared_many": "Групповая экскурсия, до {{count}} участников",
    "shared_other": "Групповая экскурсия, до {{count}} участника",
    "languages": "Языки гида: {{languages}}",
    "pickupOptions": {
      "PICKUP_EVERYONE": "Трансфер от отеля для всех участников",
      "PICKUP_AND_MEET_AT_START_POINT": "Трансфер от отеля или встреча на месте старта",
      "MEET_EVERYONE_AT_START_POINT": "Встреча на месте старта (без трансфера)"
    }
  },
  "detail": {
    "book": "Забронировать",
    "bookBoat": "Забронировать",
    "via": "через {{partner}}",
    "bookOn": "Бронирование — на сайте {{partner}}",
    "delisted": "Это предложение больше недоступно.",
    "delistedBoat": "Эта лодка больше недоступна.",
    "duration": "Длительность",
    "rating": "Рейтинг",
    "price": "Цена",
    "year": "Год постройки",
    "more": "Другие впечатления"
  },
  "footer": {
    "sisterSites": "Наши другие гиды:",
    "about": "Экскурсии, сафари в пустыне, аренда яхт и развлечения по всему Дубаю.",
    "thingsToDo": "Чем заняться",
    "areas": "Районы",
    "language": "Язык",
    "disclosure": "© dubai-todo.com · Независимый путеводитель. Некоторые ссылки партнёрские: если вы бронируете через наших партнёров, мы можем получить комиссию, для вас цена не меняется.",
    "tours": "Экскурсии и туры"
  },
  "notFound": {
    "title": "Страница не найдена",
    "text": "Такой страницы нет или она переехала.",
    "home": "На главную Dubai To-Do"
  },
  "sample": {
    "dinner": {
      "category": "Экскурсии и впечатления",
      "title": "Ужин с видом",
      "text": "Ужины на закате с незабываемым видом на Дубай.",
      "place": "Даунтаун Дубай",
      "alt": "Ресторан на террасе с видом на небоскрёбы Дубая в сумерках"
    },
    "safari": {
      "category": "Пустыня",
      "title": "Сафари класса люкс",
      "text": "Необыкновенные приключения за пределами города.",
      "place": "Заповедник пустыни Дубая",
      "alt": "Внедорожник едет по барханам на закате"
    },
    "yacht": {
      "category": "Яхты и круизы",
      "title": "Прогулка на частной яхте",
      "text": "Вдоль побережья Дубая — с полным комфортом.",
      "place": "Дубай Марина",
      "alt": "Моторная яхта на фоне небоскрёбов Дубая"
    }
  },
  "stub": {
    "saved": {
      "title": "Избранное",
      "intro": "Все понравившиеся впечатления — в одном месте.",
      "text": "Сохранять впечатления можно будет совсем скоро. А пока — несколько идей для начала."
    },
    "account": {
      "title": "Аккаунт",
      "intro": "Ваш аккаунт Dubai To-Do.",
      "text": "Аккаунты скоро появятся. А пока — несколько идей для начала."
    }
  },
  "events": {
    "metaTitle": "События в Дубае — бранчи, стендап, концерты и вечеринки",
    "metaDescription": "Куда сходить в Дубае: бранчи, стендап, концерты, пляжные клубы и шоу для всей семьи — даты, площадки и билеты.",
    "title": "Куда сходить в Дубае",
    "intro": "Бранчи, стендап, концерты, дни в пляжных клубах и семейные шоу в Дубае на ближайшие месяцы — сначала самые популярные.",
    "empty": "Афиша Дубая наполняется. А пока — несколько идей, с чего начать.",
    "filters": {
      "when": "Когда",
      "category": "Тип",
      "all": "Все",
      "whens": {
        "any": "Все даты",
        "today": "Сегодня",
        "weekend": "В эти выходные",
        "week": "Ближайшие 7 дней",
        "month": "Ближайшие 30 дней"
      },
      "loading": "Загрузка…",
      "error": "Не удалось загрузить события. Попробуйте ещё раз.",
      "none": "Под эти фильтры событий нет.",
      "count_one": "{{count}} событие",
      "count_few": "{{count}} события",
      "count_many": "{{count}} событий",
      "count_other": "{{count}} события"
    },
    "card": {
      "dateMore_one": "{{date}} + ещё {{count}} дата",
      "dateMore_few": "{{date}} + ещё {{count}} даты",
      "dateMore_many": "{{date}} + ещё {{count}} дат",
      "dateMore_other": "{{date}} + ещё {{count}} даты"
    },
    "detail": {
      "next": "Ближайшая дата",
      "dates": "Даты",
      "dateCount_one": "{{count}} дата",
      "dateCount_few": "{{count}} даты",
      "dateCount_many": "{{count}} дат",
      "dateCount_other": "{{count}} даты",
      "venue": "Площадка",
      "tickets": "Купить билеты",
      "ended": "Это событие уже прошло.",
      "upcoming": "Смотреть ближайшие события",
      "highlights": "Главное",
      "datesTitle": "Даты и время",
      "soldOut": "билетов нет",
      "moreDates_one": "и ещё {{count}} дата на странице билетов.",
      "moreDates_few": "и ещё {{count}} даты на странице билетов.",
      "moreDates_many": "и ещё {{count}} дат на странице билетов.",
      "moreDates_other": "и ещё {{count}} даты на странице билетов.",
      "venueTitle": "Площадка",
      "map": "Карта",
      "faqTitle": "Полезно знать",
      "related": "Похожие события",
      "allEvents": "Все события",
      "until": "До {{date}}"
    },
    "categories": {
      "gastronomy": "Бранчи и ужины",
      "parties": "Ночная жизнь",
      "concerts": "Концерты и музыка",
      "theatre": "Комедия и шоу",
      "family": "Для детей и семьи",
      "sport": "Спорт",
      "festivals": "Фестивали",
      "exhibitions": "Выставки и культура",
      "cinema": "Кино",
      "other": "События"
    }
  },
  "guides": {
    "metaTitle": "Путеводитель по Дубаю — советы, маршруты и чем заняться",
    "metaDescription": "Путеводитель по Дубаю: когда ехать, маршруты, советы для семей, сафари в пустыне и что бронировать — со ссылками на экскурсии и события Dubai To-Do.",
    "title": "Путеводитель по Дубаю",
    "intro": "Маршруты, советы для семей и практические подсказки, чтобы получить от Дубая максимум, — со ссылками на экскурсии и события, о которых мы пишем.",
    "empty": "Первые статьи уже пишутся. А пока — несколько идей для начала.",
    "badge": "Статья",
    "more": "Ещё статьи о Дубае",
    "all": "Весь путеводитель",
    "readAlso": "Читайте также",
    "readingTime_one": "{{count}} мин чтения",
    "readingTime_few": "{{count}} мин чтения",
    "readingTime_many": "{{count}} мин чтения",
    "readingTime_other": "{{count}} мин чтения",
    "topics": {
      "desert": "Пустыня и сафари",
      "food": "Еда и напитки",
      "seasonal": "Сезоны",
      "boats": "Лодки и пляжи",
      "tours": "Экскурсии и поездки",
      "culture": "Культура и достопримечательности",
      "shopping": "Шопинг",
      "practical": "Практические советы"
    }
  },
  "hotels": {
    "eventHeading": "Остаётесь на ночь?",
    "nearVenue": "Отели рядом с {{venue}}",
    "inCity": "Отели в Дубае",
    "dates": "{{checkin}} → {{checkout}}",
    "cta": "Смотреть отели",
    "ctaCity": "Смотреть отели в Дубае",
    "showMap": "Показать отели на карте",
    "hideMap": "Скрыть карту",
    "mapTitle": "Карта отелей поблизости",
    "sectionHeading": "Где остановиться в Дубае",
    "sectionText": "Отели, апартаменты и курорты по всему Дубаю — с ценами на ваши даты от основных сайтов бронирования.",
    "areasLink": "Какой район выбрать"
  },
  "hotelsPage": {
    "chipsLabel": "Районы на карте",
    "all": "Весь Дубай",
    "mapText": "Отели, курорты и апартаменты по всему Дубаю — с ценами на ваши даты. Карта загружается с сайта нашего партнёра Stay22.",
    "openMap": "Показать карту отелей",
    "seeAll": "Смотреть отели в Дубае",
    "areasTitle": "Районы Дубая по порядку",
    "bestFor": "Кому подходит",
    "showOnMap": "Показать на карте",
    "areas": {
      "downtown": {
        "name": "Даунтаун",
        "bestFor": "первый визит, достопримечательности, шопинг",
        "p": [
          "Бурдж-Халифа, Dubai Mall и Поющий фонтан — центр Даунтауна, а отели вокруг — от пятизвёздочных башен до апартаментов в жилых кварталах. Вечером здесь оживлённо: шоу фонтанов, рестораны молла, Souk Al Bahar.",
          "Станция метро Burj Khalifa / Dubai Mall — на красной ветке, так что до старого города и Марины одна поездка. Чего в Даунтауне нет, так это пляжа: до Джумейры 15–20 минут на такси."
        ],
        "cta": "Отели в Даунтауне",
        "thingsToDo": "Чем заняться в Даунтауне"
      },
      "business-bay": {
        "name": "Бизнес-Бэй",
        "bestFor": "Даунтаун рядом, но дешевле",
        "p": [
          "Башни офисов, отелей и апартаментов вдоль канала Dubai Water Canal, сразу за Даунтауном: от многих отелей до Dubai Mall 10–15 минут пешком или короткая поездка на такси, а цены часто ниже, чем в самом Даунтауне.",
          "Вечером приятно гулять по набережной канала; станция метро Business Bay — на красной ветке. Часть кварталов ещё строится, так что проверьте, где именно стоит ваш отель."
        ],
        "cta": "Отели в Бизнес-Бэй"
      },
      "dubai-marina": {
        "name": "Дубай Марина",
        "bestFor": "рестораны, ночная жизнь, море рядом",
        "p": [
          "Небоскрёбы вокруг канала с яхтами, у их подножия — кафе и рестораны набережной Marina Walk, а пляж JBR в паре кварталов. Многие варианты здесь — апартаменты: удобно семьям и на долгий срок.",
          "В Марине останавливаются и красная ветка метро, и трамвай; до Даунтауна 30–40 минут. Аренда яхт и ужины-круизы отправляются прямо от набережной."
        ],
        "cta": "Отели в Дубай Марине",
        "thingsToDo": "Чем заняться в Дубай Марине"
      },
      "jbr": {
        "name": "JBR — Jumeirah Beach Residence",
        "bestFor": "пляж — сразу из отеля",
        "p": [
          "Пляжная полоса рядом с Мариной: отели и апартаменты смотрят на широкий городской пляж, за ним — магазины и рестораны бульвара The Walk, а через мост — остров Bluewaters.",
          "Это самый оживлённый пляж города, в выходные людный. Трамвай связывает JBR со станциями метро в Марине."
        ],
        "cta": "Отели в JBR"
      },
      "palm-jumeirah": {
        "name": "Пальма Джумейра",
        "bestFor": "пляжные курорты, семьи, особая поездка",
        "p": [
          "На острове в форме пальмы — многие крупные курорты Дубая: Atlantis The Palm на её вершине и отели с собственными пляжами на «ветвях» и полукольце. Во многих — бассейны, детские клубы и столько ресторанов, что можно не выходить весь день.",
          "Зато Пальма в стороне от всего остального: монорельс идёт по «стволу» к трамваю Марины, а такси до Даунтауна — 25–40 минут."
        ],
        "cta": "Отели на Пальме",
        "thingsToDo": "Чем заняться на Пальме Джумейра"
      },
      "jumeirah": {
        "name": "Джумейра",
        "bestFor": "спокойные курорты на пляже",
        "p": [
          "Побережье между Даунтауном и Мариной: невысокие виллы, городские пляжи и самые известные курорты города вокруг отеля Бурдж-аль-Араб и Madinat Jumeirah с каналами и суком.",
          "Тихо и зелено, на полпути между достопримечательностями и Мариной, — но вдоль пляжа нет метро, так что ездить придётся на такси."
        ],
        "cta": "Отели в Джумейре"
      },
      "old-dubai": {
        "name": "Старый Дубай — Дейра и Бур-Дубай",
        "bestFor": "бюджет поскромнее, рынки, аэропорт рядом",
        "p": [
          "Два берега залива Крик, где начинался город: золотой рынок и рынок специй в Дейре, исторический квартал Аль-Фахиди в Бур-Дубае, а между берегами за пару монет ходят лодки-абры. Отели здесь самые доступные в Дубае, до аэропорта 10–15 минут.",
          "Метро есть на обоих берегах; до Даунтауна 15–20 минут, до пляжей дальше. Улицы шумные и традиционные, а не глянцевые, — в этом и смысл."
        ],
        "cta": "Отели в Старом Дубае",
        "thingsToDo": "Чем заняться в Старом Дубае"
      }
    }
  }
}
